/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

// DO NOT MODIFY
// FILE GENERATED BY `intl-codegen@2.2.1`
// https://github.com/eversport/intl-codegen
// DO NOT MODIFY

export default context => {
  const formatter_0 = context.n({});
  const formatter_1 = context.m({});

  return [
    // `accept-friend-request`:
    // Accept
    params => "" +
      "Accept",

    // `access-code`:
    // Access code
    params => "" +
      "Access code",

    // `activity-detail-availability-label`:
    // Availability
    params => "" +
      "Availability",

    // `activity-detail-cancellation-policy-header`:
    // Cancellation policy
    params => "" +
      "Cancellation policy",

    // `activity-detail-corporate-price-label`:
    // Corporate Deal
    params => "" +
      "Corporate Deal",

    // `activity-detail-date-label`:
    // Date
    params => "" +
      "Date",

    // `activity-detail-early-bird-price-label`:
    // Early Bird
    params => "" +
      "Early Bird",

    // `activity-detail-event-type`:
    // {eventType, select, 
    //  Camp {camp} 
    //  Class {class} 
    //  Course {course} 
    //  Education {education} 
    //  Event {event} 
    //  OpenTraining {open training} 
    //  Retreat {retreat} 
    //  Training {training} 
    //  Workshop {workshop} 
    //  other {activity}}
    params => "" +
      (
        params.eventType == "Camp" ? "" +
          "camp" :
        params.eventType == "Class" ? "" +
          "class" :
        params.eventType == "Course" ? "" +
          "course" :
        params.eventType == "Education" ? "" +
          "education" :
        params.eventType == "Event" ? "" +
          "event" :
        params.eventType == "OpenTraining" ? "" +
          "open training" :
        params.eventType == "Retreat" ? "" +
          "retreat" :
        params.eventType == "Training" ? "" +
          "training" :
        params.eventType == "Workshop" ? "" +
          "workshop" :
        "" +
          "activity"
      ),

    // `activity-detail-last-minute-price-label`:
    // Last Minute
    params => "" +
      "Last Minute",

    // `activity-detail-location-label`:
    // Location
    params => "" +
      "Location",

    // `activity-detail-membership-price-label`:
    // Membership
    params => "" +
      "Membership",

    // `activity-detail-membership-promotion-label`:
    // % Discount
    params => "" +
      "% Discount",

    // `activity-detail-multi-session-start-date`:
    // Starts on {startDate}
    params => "" +
      "Starts on " +
      params.startDate,

    // `activity-detail-multi-session-started-on-date`:
    // Started on {startDate}
    params => "" +
      "Started on " +
      params.startDate,

    // `activity-detail-multi-sessions-label`:
    // Multiple sessions - see schedule
    params => "" +
      "Multiple sessions - see schedule",

    // `activity-detail-online-label`:
    // Online
    params => "" +
      "Online",

    // `activity-detail-online-stream-header`:
    // Online stream
    params => "" +
      "Online stream",

    // `activity-detail-online-stream-instructions-step-1`:
    // This studio uses Zoom as their online streaming provider. Download the according app to your laptop, tablet or smartphone
    params => "" +
      "This studio uses Zoom as their online streaming provider. Download the according app to your laptop, tablet or smartphone",

    // `activity-detail-online-stream-instructions-step-2`:
    // Access to the online livestream is available 15 minutes before the start of the activity. Simply go to "My bookings" and click on "Join online stream now" to be redirected to the corresponding page
    params => "" +
      "Access to the online livestream is available 15 minutes before the start of the activity. Simply go to \"My bookings\" and click on \"Join online stream now\" to be redirected to the corresponding page",

    // `activity-detail-online-stream-instructions-step-3`:
    // With some streaming providers (e.g. Zoom) it is possible for participants to see each other. However, it is theoretically possible to deactivate the camera function. The name you enter when entering the online meeting room is displayed to other participants. However, you can always change your name (e.g. only the initials). Please note: Individual rules for online participation may apply for each class or venue.
    params => "" +
      "With some streaming providers (e.g. Zoom) it is possible for participants to see each other. However, it is theoretically possible to deactivate the camera function. The name you enter when entering the online meeting room is displayed to other participants. However, you can always change your name (e.g. only the initials). Please note: Individual rules for online participation may apply for each class or venue.",

    // `activity-detail-online-stream-provider-instructions`:
    // This studio uses {streamProvider, select, 
    //  HANGOUT {Google Meet} 
    //  INSTAGRAM {Instagram Live} 
    //  SKYPE {Skype} 
    //  YOUTUBE {Youtube} 
    //  YOUTUBE_LIVE {YouTube Live} 
    //  ZOOM {Zoom} 
    //  VIMEO {Vimeo} 
    //  Retreat {retreat} 
    //  OTHER {(unknown - contact the studio)} 
    //  other {(unknown - contact the studio)}} as their online streaming provider. Download the according app to your laptop, tablet or smartphone
    params => "" +
      "This studio uses " +
      (
        params.streamProvider == "HANGOUT" ? "" +
          "Google Meet" :
        params.streamProvider == "INSTAGRAM" ? "" +
          "Instagram Live" :
        params.streamProvider == "SKYPE" ? "" +
          "Skype" :
        params.streamProvider == "YOUTUBE" ? "" +
          "Youtube" :
        params.streamProvider == "YOUTUBE_LIVE" ? "" +
          "YouTube Live" :
        params.streamProvider == "ZOOM" ? "" +
          "Zoom" :
        params.streamProvider == "VIMEO" ? "" +
          "Vimeo" :
        params.streamProvider == "Retreat" ? "" +
          "retreat" :
        params.streamProvider == "OTHER" ? "" +
          "(unknown - contact the studio)" :
        "" +
          "(unknown - contact the studio)"
      ) +
      " as their online streaming provider. Download the according app to your laptop, tablet or smartphone",

    // `activity-detail-online-stream-subtext`:
    // There is an online stream available for this activity. To participate, take the following steps:
    params => "" +
      "There is an online stream available for this activity. To participate, take the following steps:",

    // `activity-detail-pricing-options-heading`:
    // Pricing options
    params => "" +
      "Pricing options",

    // `activity-detail-product-table-additional-info-header`:
    // Info
    params => "" +
      "Info",

    // `activity-detail-product-table-price-header`:
    // Price
    params => "" +
      "Price",

    // `activity-detail-product-table-pricing-option-header`:
    // Pricing option
    params => "" +
      "Pricing option",

    // `activity-detail-product-table-product-name-header`:
    // Name
    params => "" +
      "Name",

    // `activity-detail-product-table-product-price-header`:
    // Price
    params => "" +
      "Price",

    // `activity-detail-product-table-product-tags-header`:
    // Tags
    params => "" +
      "Tags",

    // `activity-detail-product-table-purchase-option-header`:
    // Purchase option
    params => "" +
      "Purchase option",

    // `activity-detail-product-table-ticket-option-header`:
    // Ticket option
    params => "" +
      "Ticket option",

    // `activity-detail-products-heading`:
    // Products
    params => "" +
      "Products",

    // `activity-detail-products-show-more`:
    // Show more
    params => "" +
      "Show more",

    // `activity-detail-reviews-show-more`:
    // Show more
    params => "" +
      "Show more",

    // `activity-detail-schedule-heading`:
    // Schedule
    params => "" +
      "Schedule",

    // `activity-detail-schedule-subheading`:
    // Check out which dates are available for this event
    params => "" +
      "Check out which dates are available for this event",

    // `activity-detail-schedule-table-date-header`:
    // Date
    params => "" +
      "Date",

    // `activity-detail-schedule-table-location-header`:
    // Location
    params => "" +
      "Location",

    // `activity-detail-schedule-table-teacher-header`:
    // Teacher
    params => "" +
      "Teacher",

    // `activity-detail-schedule-table-time-header`:
    // Time
    params => "" +
      "Time",

    // `activity-detail-ticket-options-heading`:
    // Ticket options
    params => "" +
      "Ticket options",

    // `activity-detail-ticket-past-sessions-label`:
    // Past sessions
    params => "" +
      "Past sessions",

    // `activity-detail-ticket-schedule-heading`:
    // Activity list for this ticket
    params => "" +
      "Activity list for this ticket",

    // `activity-detail-ticket-upcoming-sessions-label`:
    // Upcoming sessions
    params => "" +
      "Upcoming sessions",

    // `activity-detail-time-label`:
    // Time
    params => "" +
      "Time",

    // `activity-detail-trial-price-label`:
    // Intro Offer
    params => "" +
      "Intro Offer",

    // `activity-details-already-registered`:
    // Already registered
    params => "" +
      "Already registered",

    // `activity-details-book-now`:
    // Book now
    params => "" +
      "Book now",

    // `activity-details-book-now-from`:
    // Book now from {cheapestPrice}
    params => "" +
      "Book now from " +
      formatter_1(params.cheapestPrice),

    // `activity-details-calendar-description`:
    // Book your class here: {activityUrl}
    params => "" +
      "Book your class here: " +
      params.activityUrl,

    // `activity-details-calendar-summary`:
    // {sportName} {eventType, select, 
    //  Camp {camp} 
    //  Class {class} 
    //  Course {course} 
    //  Education {education} 
    //  Event {event} 
    //  OpenTraining {open training} 
    //  Retreat {retreat} 
    //  Training {training} 
    //  Workshop {workshop} 
    //  other {activity}} - {activityName}
    params => "" +
      params.sportName +
      " " +
      (
        params.eventType == "Camp" ? "" +
          "camp" :
        params.eventType == "Class" ? "" +
          "class" :
        params.eventType == "Course" ? "" +
          "course" :
        params.eventType == "Education" ? "" +
          "education" :
        params.eventType == "Event" ? "" +
          "event" :
        params.eventType == "OpenTraining" ? "" +
          "open training" :
        params.eventType == "Retreat" ? "" +
          "retreat" :
        params.eventType == "Training" ? "" +
          "training" :
        params.eventType == "Workshop" ? "" +
          "workshop" :
        "" +
          "activity"
      ) +
      " - " +
      params.activityName,

    // `activity-details-difficulty-header`:
    // Level
    params => "" +
      "Level",

    // `activity-details-event-already-occured-label`:
    // Already concluded
    params => "" +
      "Already concluded",

    // `activity-details-event-bookable-from-label`:
    // Bookable from {registrationStartDate}
    params => "" +
      "Bookable from " +
      params.registrationStartDate,

    // `activity-details-event-fully-booked-label`:
    // Fully booked
    params => "" +
      "Fully booked",

    // `activity-details-event-is-cancelled-label`:
    // Cancelled
    params => "" +
      "Cancelled",

    // `activity-details-generic-availability-remaining`:
    // more than {freeSpots}
    params => "" +
      "more than " +
      formatter_0(params.freeSpots),

    // `activity-details-language-header`:
    // Language
    params => "" +
      "Language",

    // `activity-details-location-header`:
    // Location
    params => "" +
      "Location",

    // `activity-details-membership-price`:
    // {recurringValue} / {intervalValue, select, 
    //  1 {} 
    //  other {{intervalValue}}} {intervalType, select, 
    //  INTERVAL_UNIT_DAYS {{intervalValue, plural, =1 {day}
    //  other {days}}} 
    //  INTERVAL_UNIT_HOURS {{intervalValue, plural, =1 {hour}
    //  other {hours}}} 
    //  INTERVAL_UNIT_MONTHS {{intervalValue, plural, =1 {month}
    //  other {months}}} 
    //  INTERVAL_UNIT_WEEKS {{intervalValue, plural, =1 {week}
    //  other {weeks}}} 
    //  INTERVAL_UNIT_YEARS {{intervalValue, plural, =1 {year}
    //  other {years}}} 
    //  other {period}}
    params => "" +
      formatter_1(params.recurringValue) +
      " / " +
      (
        params.intervalValue == "1" ? "" :
        "" +
          formatter_0(params.intervalValue)
      ) +
      " " +
      (
        params.intervalType == "INTERVAL_UNIT_DAYS" ? "" +
          (
            params.intervalValue == 1 ? "" +
              "day" :
            "" +
              "days"
          ) :
        params.intervalType == "INTERVAL_UNIT_HOURS" ? "" +
          (
            params.intervalValue == 1 ? "" +
              "hour" :
            "" +
              "hours"
          ) :
        params.intervalType == "INTERVAL_UNIT_MONTHS" ? "" +
          (
            params.intervalValue == 1 ? "" +
              "month" :
            "" +
              "months"
          ) :
        params.intervalType == "INTERVAL_UNIT_WEEKS" ? "" +
          (
            params.intervalValue == 1 ? "" +
              "week" :
            "" +
              "weeks"
          ) :
        params.intervalType == "INTERVAL_UNIT_YEARS" ? "" +
          (
            params.intervalValue == 1 ? "" +
              "year" :
            "" +
              "years"
          ) :
        "" +
          "period"
      ),

    // `activity-details-meta-description`:
    // Check out this {sportName} activity and many more on Eversports - offerings thousands of classes, workshops, and courts near you.
    params => "" +
      "Check out this " +
      params.sportName +
      " activity and many more on Eversports - offerings thousands of classes, workshops, and courts near you.",

    // `activity-details-multiple-locations`:
    // Multiple locations - see schedule
    params => "" +
      "Multiple locations - see schedule",

    // `activity-details-not-bookable`:
    // Not bookable
    params => "" +
      "Not bookable",

    // `activity-details-online-location`:
    // Online
    params => "" +
      "Online",

    // `activity-details-room-header`:
    // Room
    params => "" +
      "Room",

    // `activity-details-specific-availability-remaining`:
    // {freeSpots} remaining
    params => "" +
      formatter_0(params.freeSpots) +
      " remaining",

    // `activity-details-teacher-heading`:
    // {trainerCount, plural, =1 {Teacher}
    //  other {Teachers}}
    params => "" +
      (
        params.trainerCount == 1 ? "" +
          "Teacher" :
        "" +
          "Teachers"
      ),

    // `activity-details-teacher-label`:
    // teacher
    params => "" +
      "teacher",

    // `activity-details-trainer-description`:
    // About
    params => "" +
      "About",

    // `activity-details-trainer-education`:
    // Education
    params => "" +
      "Education",

    // `activity-details-trainer-heading`:
    // {trainerCount, plural, =1 {Trainer}
    //  other {Trainers}}
    params => "" +
      (
        params.trainerCount == 1 ? "" +
          "Trainer" :
        "" +
          "Trainers"
      ),

    // `activity-details-trainer-label`:
    // trainer
    params => "" +
      "trainer",

    // `activity-details-unlimited-availability`:
    // Unlimited
    params => "" +
      "Unlimited",

    // `activity-details-urgency-limited-spots`:
    // Only {freeSpots, selectordinal, =1 {one}
    //  =2 {two}
    //  =3 {three}
    //  =4 {four}
    //  other {a few}} {freeSpots, plural, =1 {spot}
    //  other {spots}} left!
    params => "" +
      "Only " +
      (
        params.freeSpots == 1 ? "" +
          "one" :
        params.freeSpots == 2 ? "" +
          "two" :
        params.freeSpots == 3 ? "" +
          "three" :
        params.freeSpots == 4 ? "" +
          "four" :
        "" +
          "a few"
      ) +
      " " +
      (
        params.freeSpots == 1 ? "" +
          "spot" :
        "" +
          "spots"
      ) +
      " left!",

    // `activity-details-venue-information-header`:
    // Venue information
    params => "" +
      "Venue information",

    // `activity-details-venue-profile-link-aria-label`:
    // Venue overview page for {venueName}
    params => "" +
      "Venue overview page for " +
      params.venueName,

    // `activity-details-venue-reviews-header`:
    // Reviews
    params => "" +
      "Reviews",

    // `activity-difficulty-all-levels`:
    // All Levels
    params => "" +
      "All Levels",

    // `activity-difficulty-all-levels-description`:
    // Suitable for beginners, intermediate, and advanced participants.
    params => "" +
      "Suitable for beginners, intermediate, and advanced participants.",

    // `activity-difficulty-beginner`:
    // Beginner
    params => "" +
      "Beginner",

    // `activity-difficulty-beginner-description`:
    // Suitable for participants with little to no prior experience.
    params => "" +
      "Suitable for participants with little to no prior experience.",

    // `activity-difficulty-intermediate`:
    // Intermediate
    params => "" +
      "Intermediate",

    // `activity-difficulty-intermediate-description`:
    // Best for participants with a moderate level of experience and skill in the sport.
    params => "" +
      "Best for participants with a moderate level of experience and skill in the sport.",

    // `activity-difficulty-not-specified`:
    // Not specified
    params => "" +
      "Not specified",

    // `activity-difficulty-professional`:
    // Advanced
    params => "" +
      "Advanced",

    // `activity-difficulty-professional-description`:
    // Recommended for participants with a high level expertise and knowledge in the sport.
    params => "" +
      "Recommended for participants with a high level expertise and knowledge in the sport.",

    // `activity-duration-in-minutes-short`:
    // ({duration} min)
    params => "" +
      "(" +
      formatter_0(params.duration) +
      " min)",

    // `activity-event-type-camp`:
    // Camp
    params => "" +
      "Camp",

    // `activity-event-type-class`:
    // Class
    params => "" +
      "Class",

    // `activity-event-type-course`:
    // Course
    params => "" +
      "Course",

    // `activity-event-type-education`:
    // Education
    params => "" +
      "Education",

    // `activity-event-type-event`:
    // Event
    params => "" +
      "Event",

    // `activity-event-type-open-training`:
    // Training
    params => "" +
      "Training",

    // `activity-event-type-retreat`:
    // Retreat
    params => "" +
      "Retreat",

    // `activity-event-type-training`:
    // Training
    params => "" +
      "Training",

    // `activity-event-type-workshop`:
    // Workshop
    params => "" +
      "Workshop",

    // `activity-single-session-sharing-message`:
    // Hey, I found this {sportName} {eventType, select, 
    //  Camp {camp} 
    //  Class {class} 
    //  Course {course} 
    //  Education {education} 
    //  Event {event} 
    //  OpenTraining {training} 
    //  Retreat {retreat} 
    //  Training {training} 
    //  Workshop {workshop} 
    //  other {activity}} on Eversports: {activityName} 
    //  
    //  📅 {dayOfTheWeek}, {formattedDate} 
    //  ⏰ {startTime} - {endTime} ({duration} min) 
    //  🏠 {venueName} 
    //  {trainerName, select, 
    //  unknown {👫 No trainer specified} 
    //  other {👫 Instructed by {trainerName}}}  
    //  
    //  ➡️ Save your spot here: {activityUrl}
    params => "" +
      "Hey, I found this " +
      params.sportName +
      " " +
      (
        params.eventType == "Camp" ? "" +
          "camp" :
        params.eventType == "Class" ? "" +
          "class" :
        params.eventType == "Course" ? "" +
          "course" :
        params.eventType == "Education" ? "" +
          "education" :
        params.eventType == "Event" ? "" +
          "event" :
        params.eventType == "OpenTraining" ? "" +
          "training" :
        params.eventType == "Retreat" ? "" +
          "retreat" :
        params.eventType == "Training" ? "" +
          "training" :
        params.eventType == "Workshop" ? "" +
          "workshop" :
        "" +
          "activity"
      ) +
      " on Eversports: " +
      params.activityName +
      " \n \n 📅 " +
      params.dayOfTheWeek +
      ", " +
      params.formattedDate +
      " \n ⏰ " +
      params.startTime +
      " - " +
      params.endTime +
      " (" +
      formatter_0(params.duration) +
      " min) \n 🏠 " +
      params.venueName +
      " \n " +
      (
        params.trainerName == "unknown" ? "" +
          "👫 No trainer specified" :
        "" +
          "👫 Instructed by " +
          params.trainerName
      ) +
      "  \n \n ➡️ Save your spot here: " +
      params.activityUrl,

    // `add-friend`:
    // Add
    params => "" +
      "Add",

    // `add-new-comment-placeholder`:
    // Add a comment
    params => "" +
      "Add a comment",

    // `add-to-calendar-alt-text`:
    // Add to calendar
    params => "" +
      "Add to calendar",

    // `add-to-friends-button-text`:
    // Add to friends
    params => "" +
      "Add to friends",

    // `add-venue-to-favorites`:
    // Add to Favorites
    params => "" +
      "Add to Favorites",

    // `all-public-matches-in-city-call-to-action`:
    // or {matchesInCityLink}
    params => [
      "or ",
      params.matchesInCityLink,
    ],

    // `all-public-matches-in-city-link`:
    // Want to see more? Check out all public matches in {cityName}!
    params => "" +
      "Want to see more? Check out all public matches in " +
      params.cityName +
      "!",

    // `all-sports-heading`:
    // All Sports
    params => "" +
      "All Sports",

    // `another-user-profile-sharing-message`:
    // View {firstName}'s Profile on Eversports!
    //  ➡️ {url}
    params => "" +
      "View " +
      params.firstName +
      "'s Profile on Eversports!\n ➡️ " +
      params.url,

    // `approve-friend-request`:
    // Approve
    params => "" +
      "Approve",

    // `approve-friend-request-button-text`:
    // Approve request
    params => "" +
      "Approve request",

    // `assumption-test-friends-connection-beta-tester-button`:
    // Yes, sign me up as a beta tester
    params => "" +
      "Yes, sign me up as a beta tester",

    // `assumption-test-friends-connection-beta-tester-text`:
    // Would you like to get early access to the feature when it's available?
    params => "" +
      "Would you like to get early access to the feature when it's available?",

    // `assumption-test-friends-connection-sub-title`:
    // We are currently working on the possibility to connect with friends on Eversports.
    params => "" +
      "We are currently working on the possibility to connect with friends on Eversports.",

    // `assumption-test-friends-connection-title`:
    // Thank you for your interest!
    params => "" +
      "Thank you for your interest!",

    // `assumption-test-friends-user-profile-add-to-friends-button`:
    // Add to friends
    params => "" +
      "Add to friends",

    // `back`:
    // Back
    params => "" +
      "Back",

    // `back-home`:
    // Back Home
    params => "" +
      "Back Home",

    // `back-link`:
    // back
    params => "" +
      "back",

    // `back-to-home`:
    // Go back to Home
    params => "" +
      "Go back to Home",

    // `back-to-profile`:
    // Back to Profile
    params => "" +
      "Back to Profile",

    // `back-to-user-profile`:
    // Back to {userFirstName}'s profile
    params => "" +
      "Back to " +
      params.userFirstName +
      "'s profile",

    // `badminton`:
    // Badminton
    params => "" +
      "Badminton",

    // `barre`:
    // Barre
    params => "" +
      "Barre",

    // `bauch-beine-po`:
    // Belly-Butt-Thigh
    params => "" +
      "Belly-Butt-Thigh",

    // `bookable-sports-in-city-heading`:
    // If you like {sportName} in {cityName} you might also be interested in the following
    params => "" +
      "If you like " +
      params.sportName +
      " in " +
      params.cityName +
      " you might also be interested in the following",

    // `booking-state-accepted`:
    // Approved
    params => "" +
      "Approved",

    // `booking-state-cancelled`:
    // Cancelled
    params => "" +
      "Cancelled",

    // `booking-state-moved`:
    // Booking Changed
    params => "" +
      "Booking Changed",

    // `booking-state-rejected`:
    // Rejected by venue
    params => "" +
      "Rejected by venue",

    // `booking-state-requested`:
    // Pending request
    params => "" +
      "Pending request",

    // `boxen`:
    // Boxing
    params => "" +
      "Boxing",

    // `branches-modal-cancel`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `branches-modal-other-locations`:
    // Other locations
    params => "" +
      "Other locations",

    // `branches-section-subtitle`:
    // Check out other locations of the venue
    params => "" +
      "Check out other locations of the venue",

    // `branches-section-title`:
    // Other locations
    params => "" +
      "Other locations",

    // `branches-view-other-locations`:
    // View other locations
    params => "" +
      "View other locations",

    // `breadcrumb-navigation-invoice-history`:
    // Invoice history
    params => "" +
      "Invoice history",

    // `breadcrumb-navigation-item-home`:
    // Home
    params => "" +
      "Home",

    // `breadcrumb-navigation-item-notifications`:
    // Notifications
    params => "" +
      "Notifications",

    // `breadcrumb-navigation-item-passes-and-memberships`:
    // Passes & Memberships
    params => "" +
      "Passes & Memberships",

    // `breadcrumb-navigation-item-user-friend-profile`:
    // {userFirstName}'s profile
    params => "" +
      params.userFirstName +
      "'s profile",

    // `breadcrumb-navigation-item-user-friends`:
    // Friends
    params => "" +
      "Friends",

    // `breadcrumb-navigation-item-user-profile`:
    // My Account
    params => "" +
      "My Account",

    // `breadcrumb-navigation-item-user-public-profile`:
    // Public Profile
    params => "" +
      "Public Profile",

    // `breadcrumbs-calendar`:
    // {venueName} Calendar
    params => "" +
      params.venueName +
      " Calendar",

    // `breadcrumbs-discover-sport-matches-in-city`:
    // {sportSlug} in {citySlug} - Matches
    params => "" +
      params.sportSlug +
      " in " +
      params.citySlug +
      " - Matches",

    // `breadcrumbs-my-bookings`:
    // My bookings
    params => "" +
      "My bookings",

    // `breadcrumbs-venue-profile-matches`:
    // {venueName} - Matches
    params => "" +
      params.venueName +
      " - Matches",

    // `camp-offering-heading`:
    // Camps
    params => "" +
      "Camps",

    // `cancel-match`:
    // Cancel
    params => "" +
      "Cancel",

    // `cancel-match-and-booking`:
    // Cancel booking
    params => "" +
      "Cancel booking",

    // `cancel-modal-confirm-cancel`:
    // Cancel booking
    params => "" +
      "Cancel booking",

    // `cancel-modal-information`:
    // Are you sure you want to cancel?
    params => "" +
      "Are you sure you want to cancel?",

    // `cancellation-conditions-header-for-organizers`:
    // Cancelation conditions:
    params => "" +
      "Cancelation conditions:",

    // `classes-and-trainings-offering-heading`:
    // Classes & Trainings
    params => "" +
      "Classes & Trainings",

    // `classes-offering-heading`:
    // Classes
    params => "" +
      "Classes",

    // `click-here-to`:
    // Check out
    params => "" +
      "Check out",

    // `comments-section-notifications-title`:
    // Notifications
    params => "" +
      "Notifications",

    // `comments-section-title`:
    // Comments
    params => "" +
      "Comments",

    // `comments-section-view-more-comments`:
    // View previous comments
    params => "" +
      "View previous comments",

    // `confirmation-disclaimer-received-friendship-request-decline-request`:
    // Decline request
    params => "" +
      "Decline request",

    // `confirmation-disclaimer-received-friendship-request-description`:
    // If you decline the friend request, the other person will not be notified. 
    params => "" +
      "If you decline the friend request, the other person will not be notified. ",

    // `confirmation-disclaimer-received-friendship-request-dismiss`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `confirmation-disclaimer-received-friendship-request-title`:
    // Decline friend request?
    params => "" +
      "Decline friend request?",

    // `confirmation-disclaimer-remove-friendship`:
    // Remove friend
    params => "" +
      "Remove friend",

    // `confirmation-disclaimer-remove-friendship-description`:
    // If you remove a friend, you will no longer see their upcoming activities. Your friend will not be notified about the removal. You can send a new friend request to them at any time.
    params => "" +
      "If you remove a friend, you will no longer see their upcoming activities. Your friend will not be notified about the removal. You can send a new friend request to them at any time.",

    // `confirmation-disclaimer-remove-friendship-dismiss`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `confirmation-disclaimer-remove-friendship-title`:
    // Remove friend?
    params => "" +
      "Remove friend?",

    // `confirmation-disclaimer-requested-friendship-cancel-request`:
    // Cancel request
    params => "" +
      "Cancel request",

    // `confirmation-disclaimer-requested-friendship-description`:
    // If you delete your friend request, the other person will not be notified. 
    params => "" +
      "If you delete your friend request, the other person will not be notified. ",

    // `confirmation-disclaimer-requested-friendship-dismiss`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `confirmation-disclaimer-requested-friendship-title`:
    // Cancel friend request?
    params => "" +
      "Cancel friend request?",

    // `connect-to-see-more-content`:
    //  Connect to {firstName} to see their {field, select, 
    //  UPCOMING_BOOKINGS {upcoming activities} 
    //  FAVORITE_VENUES {favorite venues} 
    //  FRIENDS {friends}
    //  other {}}
    params => "" +
      " Connect to " +
      params.firstName +
      " to see their " +
      (
        params.field == "UPCOMING_BOOKINGS" ? "" +
          "upcoming activities" :
        params.field == "FAVORITE_VENUES" ? "" +
          "favorite venues" :
        params.field == "FRIENDS" ? "" +
          "friends" :
        ""
      ),

    // `continue-to-my-bookings`:
    // Continue to my bookings
    params => "" +
      "Continue to my bookings",

    // `cookie-banner-accept`:
    // Accept all
    params => "" +
      "Accept all",

    // `cookie-banner-confirm`:
    // Confirm selection
    params => "" +
      "Confirm selection",

    // `cookie-banner-cookie-preferences`:
    // Cookie preferences
    params => "" +
      "Cookie preferences",

    // `cookie-banner-description-long`:
    // We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time by going to the home page and selecting "Cookie Settings" at the bottom of the page.
    params => "" +
      "We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time by going to the home page and selecting \"Cookie Settings\" at the bottom of the page.",

    // `cookie-banner-description-short`:
    // We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time.
    params => "" +
      "We use cookies so that we can offer you the best possible website experience. You are free to decide which categories you would like to permit. You can edit your cookie settings at any time.",

    // `cookie-banner-further-information`:
    // Further information regarding cookies and privacy policies at Eversports can be found in the {privacyPolicy} . Details regarding how we store cookies can be found in the {technicalNotes}
    params => [
      "Further information regarding cookies and privacy policies at Eversports can be found in the ",
      params.privacyPolicy,
      " . Details regarding how we store cookies can be found in the ",
      params.technicalNotes,
    ],

    // `cookie-banner-label-advertising`:
    // Advertising
    params => "" +
      "Advertising",

    // `cookie-banner-label-advertising-description`:
    // In order to track the performance of advertising efforts and ensure more personalised advertising, this site uses Google Analytics, Google Tag Manager, and Google Ads, which are solutions operated by Google LLC based in California, USA. These platforms use third-party tags, and controls when data is triggered. Personal data, such as IP address, might be processed.
    params => "" +
      "In order to track the performance of advertising efforts and ensure more personalised advertising, this site uses Google Analytics, Google Tag Manager, and Google Ads, which are solutions operated by Google LLC based in California, USA. These platforms use third-party tags, and controls when data is triggered. Personal data, such as IP address, might be processed.",

    // `cookie-banner-label-analytics`:
    // Analytics Cookies
    params => "" +
      "Analytics Cookies",

    // `cookie-banner-label-analytics-description`:
    // In order to continuously improve our website, we anonymously track data for statistical and analytical purposes. With these cookies we can, for example, track the number of visits or the impact of specific pages of our web presence and therefore optimize our content.
    params => "" +
      "In order to continuously improve our website, we anonymously track data for statistical and analytical purposes. With these cookies we can, for example, track the number of visits or the impact of specific pages of our web presence and therefore optimize our content.",

    // `cookie-banner-label-necessary`:
    // Essential Cookies
    params => "" +
      "Essential Cookies",

    // `cookie-banner-label-necessary-description`:
    // These cookies are necessary to run the core functionalities of this website, e.g. security related functions. With these cookies we can also detect if you want to stay logged into your profile to provide you with fast access to our services after revisiting our website.
    params => "" +
      "These cookies are necessary to run the core functionalities of this website, e.g. security related functions. With these cookies we can also detect if you want to stay logged into your profile to provide you with fast access to our services after revisiting our website.",

    // `cookie-banner-privacy-policy`:
    // Privacy Policy
    params => "" +
      "Privacy Policy",

    // `cookie-banner-technical-notes`:
    // Technical Notes
    params => "" +
      "Technical Notes",

    // `cookie-banner-title`:
    // Cookie Settings
    params => "" +
      "Cookie Settings",

    // `corporate-benefits-aria-label`:
    // Corporate benefits
    params => "" +
      "Corporate benefits",

    // `corporate-deal-label`:
    // Corporate deal
    params => "" +
      "Corporate deal",

    // `corporate-deal-modal-subheading`:
    // This venue provides exclusive discounts to users whose employer is part of the Eversports Corporate Program.
    params => "" +
      "This venue provides exclusive discounts to users whose employer is part of the Eversports Corporate Program.",

    // `corporate-partner-promo-text`:
    // Did you know your company can help support your sports routine? {link}
    params => [
      "Did you know your company can help support your sports routine? ",
      params.link,
    ],

    // `corporate-partner-promo-text-link`:
    // Learn more here
    params => "" +
      "Learn more here",

    // `courses-offering-heading`:
    // Courses
    params => "" +
      "Courses",

    // `courses-offering-heading-v2`:
    // Learn a New Skill
    params => "" +
      "Learn a New Skill",

    // `court-slots-nothing-available-on-the-day`:
    // No available court on the selected day
    params => "" +
      "No available court on the selected day",

    // `create-your-match-card-step-1`:
    // Book a court
    params => "" +
      "Book a court",

    // `create-your-match-card-step-2`:
    // Set your booking to public and it’s listed here
    params => "" +
      "Set your booking to public and it’s listed here",

    // `create-your-match-card-sub-title`:
    // By booking a court and converting it to a public match
    params => "" +
      "By booking a court and converting it to a public match",

    // `create-your-match-card-title`:
    // How to create a public match
    params => "" +
      "How to create a public match",

    // `crossfit`:
    // CrossFit®
    params => "" +
      "CrossFit®",

    // `data-sub-processors-heading`:
    // Technical notes
    params => "" +
      "Technical notes",

    // `date_unit_day`:
    // day
    params => "" +
      "day",

    // `date_unit_day_plural`:
    // Days
    params => "" +
      "Days",

    // `date_unit_game`:
    // Game
    params => "" +
      "Game",

    // `date_unit_game_plural`:
    // Games
    params => "" +
      "Games",

    // `date_unit_hour`:
    // Hours
    params => "" +
      "Hours",

    // `date_unit_hour_plural`:
    // Hours
    params => "" +
      "Hours",

    // `date_unit_minute`:
    // minute
    params => "" +
      "minute",

    // `date_unit_minute_plural`:
    // Minutes
    params => "" +
      "Minutes",

    // `date_unit_month`:
    // month
    params => "" +
      "month",

    // `date_unit_month_plural`:
    // Months
    params => "" +
      "Months",

    // `date_unit_season`:
    // season
    params => "" +
      "season",

    // `date_unit_season_plural`:
    // seasons
    params => "" +
      "seasons",

    // `date_unit_unit`:
    // unit
    params => "" +
      "unit",

    // `date_unit_unit_plural`:
    // Sessions
    params => "" +
      "Sessions",

    // `date_unit_week`:
    // week
    params => "" +
      "week",

    // `date_unit_week_plural`:
    // weeks
    params => "" +
      "weeks",

    // `date_unit_weekend`:
    // weekend
    params => "" +
      "weekend",

    // `date_unit_weekend_plural`:
    // weekends
    params => "" +
      "weekends",

    // `date_unit_year`:
    // year
    params => "" +
      "year",

    // `date_unit_year_plural`:
    // years
    params => "" +
      "years",

    // `date-time-relative-to-now`:
    // {timeFrame, select, 
    //  years {{timeValue, plural, =1 {a year} other {{timeValue} years}}} 
    //  months {{timeValue, plural, =1 {a month} other {{timeValue} months}}} 
    //  days {{timeValue, plural, =1 {a day} other {{timeValue} days}}} 
    //  hours {{timeValue, plural, =1 {an hour} other {{timeValue} hours}}} 
    //  minutes {{timeValue, plural, =1 {a minute} other {{timeValue} minutes}}} 
    //  seconds {{timeValue, plural, =1 {a second} other {{timeValue} seconds}}} other {unknown time}} ago
    params => "" +
      (
        params.timeFrame == "years" ? "" +
          (
            params.timeValue == 1 ? "" +
              "a year" :
            "" +
              formatter_0(params.timeValue) +
              " years"
          ) :
        params.timeFrame == "months" ? "" +
          (
            params.timeValue == 1 ? "" +
              "a month" :
            "" +
              formatter_0(params.timeValue) +
              " months"
          ) :
        params.timeFrame == "days" ? "" +
          (
            params.timeValue == 1 ? "" +
              "a day" :
            "" +
              formatter_0(params.timeValue) +
              " days"
          ) :
        params.timeFrame == "hours" ? "" +
          (
            params.timeValue == 1 ? "" +
              "an hour" :
            "" +
              formatter_0(params.timeValue) +
              " hours"
          ) :
        params.timeFrame == "minutes" ? "" +
          (
            params.timeValue == 1 ? "" +
              "a minute" :
            "" +
              formatter_0(params.timeValue) +
              " minutes"
          ) :
        params.timeFrame == "seconds" ? "" +
          (
            params.timeValue == 1 ? "" +
              "a second" :
            "" +
              formatter_0(params.timeValue) +
              " seconds"
          ) :
        "" +
          "unknown time"
      ) +
      " ago",

    // `day-of-the-week`:
    // {dayOfTheWeekIndex, select, 
    //  0 {Sunday} 
    //  1 {Monday} 
    //  2 {Tuesday} 
    //  3 {Wednesday} 
    //  4 {Thursday} 
    //  5 {Friday} 
    //  6 {Saturday} 
    //  other {}}
    params => "" +
      (
        params.dayOfTheWeekIndex == "0" ? "" +
          "Sunday" :
        params.dayOfTheWeekIndex == "1" ? "" +
          "Monday" :
        params.dayOfTheWeekIndex == "2" ? "" +
          "Tuesday" :
        params.dayOfTheWeekIndex == "3" ? "" +
          "Wednesday" :
        params.dayOfTheWeekIndex == "4" ? "" +
          "Thursday" :
        params.dayOfTheWeekIndex == "5" ? "" +
          "Friday" :
        params.dayOfTheWeekIndex == "6" ? "" +
          "Saturday" :
        ""
      ),

    // `discover-no-results-city`:
    // Sorry, no results found for city "{citySlug}"
    params => "" +
      "Sorry, no results found for city \"" +
      params.citySlug +
      "\"",

    // `discover-no-results-description`:
    // Please try another search term, or check out one of these suggestions below.
    params => "" +
      "Please try another search term, or check out one of these suggestions below.",

    // `discover-no-results-livestreams`:
    // Livestream activties
    params => "" +
      "Livestream activties",

    // `discover-no-results-online-offerings-label`:
    // Online offerings
    params => "" +
      "Online offerings",

    // `discover-no-results-popular-cities-label`:
    // View sports in other cities
    params => "" +
      "View sports in other cities",

    // `discover-no-results-popular-sports-label`:
    // Other popular sports in {city}
    params => "" +
      "Other popular sports in " +
      params.city,

    // `discover-no-results-sport-city`:
    // Sorry, no results found for sport "{sportSlug}" in "{citySlug}"
    params => "" +
      "Sorry, no results found for sport \"" +
      params.sportSlug +
      "\" in \"" +
      params.citySlug +
      "\"",

    // `discover-no-results-videos`:
    // Videos
    params => "" +
      "Videos",

    // `dismiss-action`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `dismiss-players-removal-button`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `download-app-description`:
    // Syncing your contacts only works on our apps for now. You can download the app via your device link below
    params => "" +
      "Syncing your contacts only works on our apps for now. You can download the app via your device link below",

    // `download-app-title`:
    // Download our App
    params => "" +
      "Download our App",

    // `download-invoice-is-generating-label`:
    // Generating
    params => "" +
      "Generating",

    // `download-invoice-label`:
    // Invoice
    params => "" +
      "Invoice",

    // `download-progress-please-check-back-soon`:
    // Please check back in a few minutes.
    params => "" +
      "Please check back in a few minutes.",

    // `edit-profile-privacy-call-to-action`:
    // Edit privacy settings
    params => "" +
      "Edit privacy settings",

    // `education-offering-heading`:
    // Education
    params => "" +
      "Education",

    // `empty-list-result-description`:
    // We couldn't find bookable studios matching your selected filters in this area.
    params => "" +
      "We couldn't find bookable studios matching your selected filters in this area.",

    // `empty-list-result-title`:
    // Sorry
    params => "" +
      "Sorry",

    // `event-by-label`:
    // by:
    params => "" +
      "by:",

    // `events-offering-heading`:
    // Events
    params => "" +
      "Events",

    // `eversports`:
    // Eversports
    params => "" +
      "Eversports",

    // `fake-notification-header-1`:
    // Max just sent you a friend request!
    params => "" +
      "Max just sent you a friend request!",

    // `fake-notification-header-2`:
    // Sarah wants to know if you will join her at: Candlelight Yoga
    params => "" +
      "Sarah wants to know if you will join her at: Candlelight Yoga",

    // `faq-type-extra-info-to-know`:
    // What else should I know?
    params => "" +
      "What else should I know?",

    // `faq-type-what-to-know-about-cancelling`:
    // What should I do if I have booked but cannot come?
    params => "" +
      "What should I do if I have booked but cannot come?",

    // `faq-type-what-to-know-about-needed-equipment`:
    // Do I have to bring my own equipment or is it possible to borrow some at the venue?
    params => "" +
      "Do I have to bring my own equipment or is it possible to borrow some at the venue?",

    // `faq-type-what-to-know-for-first-visit`:
    // What should I know for my first visit?
    params => "" +
      "What should I know for my first visit?",

    // `faq-type-why-visit-this-venue`:
    // What makes {venueName} special? 
    params => "" +
      "What makes " +
      params.venueName +
      " special? ",

    // `filters-activities-availability-afternoon`:
    // Afternoon
    params => "" +
      "Afternoon",

    // `filters-activities-availability-evening`:
    // Evening
    params => "" +
      "Evening",

    // `filters-activities-availability-heading`:
    // Times
    params => "" +
      "Times",

    // `filters-activities-availability-morning`:
    // Morning
    params => "" +
      "Morning",

    // `filters-amenities-heading`:
    // Amenities
    params => "" +
      "Amenities",

    // `filters-court-all-selected`:
    // All
    params => "" +
      "All",

    // `filters-court-area-heading`:
    // Indoor/outdoor
    params => "" +
      "Indoor/outdoor",

    // `filters-court-area-indoor`:
    // Indoor
    params => "" +
      "Indoor",

    // `filters-court-area-outdoor`:
    // Outdoor
    params => "" +
      "Outdoor",

    // `filters-court-surface-heading`:
    // Surface
    params => "" +
      "Surface",

    // `filters-court-surface-type-artificial-grass`:
    // Artificial grass
    params => "" +
      "Artificial grass",

    // `filters-court-surface-type-artificial-ice`:
    // Artificial ice
    params => "" +
      "Artificial ice",

    // `filters-court-surface-type-ash`:
    // Ash
    params => "" +
      "Ash",

    // `filters-court-surface-type-asphalt`:
    // Asphalt
    params => "" +
      "Asphalt",

    // `filters-court-surface-type-carpet`:
    // Carpet
    params => "" +
      "Carpet",

    // `filters-court-surface-type-carpet-granule`:
    // Carpet granule
    params => "" +
      "Carpet granule",

    // `filters-court-surface-type-concrete`:
    // Concrete
    params => "" +
      "Concrete",

    // `filters-court-surface-type-felt`:
    // Felt
    params => "" +
      "Felt",

    // `filters-court-surface-type-granuale`:
    // Granule
    params => "" +
      "Granule",

    // `filters-court-surface-type-grass`:
    // Natural grass
    params => "" +
      "Natural grass",

    // `filters-court-surface-type-hard-court`:
    // Hard court
    params => "" +
      "Hard court",

    // `filters-court-surface-type-ice`:
    // Ice
    params => "" +
      "Ice",

    // `filters-court-surface-type-opticourt`:
    // Opticourt
    params => "" +
      "Opticourt",

    // `filters-court-surface-type-parquet`:
    // Parquet
    params => "" +
      "Parquet",

    // `filters-court-surface-type-pvc`:
    // PVC
    params => "" +
      "PVC",

    // `filters-court-surface-type-red-court`:
    // RedCourt
    params => "" +
      "RedCourt",

    // `filters-court-surface-type-sand`:
    // Sand
    params => "" +
      "Sand",

    // `filters-court-surface-type-synthetic`:
    // Synthetic
    params => "" +
      "Synthetic",

    // `filters-court-surface-type-tartan`:
    // Tartan
    params => "" +
      "Tartan",

    // `filters-court-surface-type-water`:
    // Water
    params => "" +
      "Water",

    // `filters-matches-competition-type-heading`:
    // Competition Type
    params => "" +
      "Competition Type",

    // `filters-matches-level-heading`:
    // Level
    params => "" +
      "Level",

    // `filters-matches-sports-heading`:
    // Sport
    params => "" +
      "Sport",

    // `filters-matches-venues-heading`:
    // Venues
    params => "" +
      "Venues",

    // `filters-reset`:
    // Reset
    params => "" +
      "Reset",

    // `filters-reset-all`:
    // Reset all filters
    params => "" +
      "Reset all filters",

    // `filters-review-count-heading`:
    // Number of reviews
    params => "" +
      "Number of reviews",

    // `filters-studio-activities-heading`:
    // Studio Offering
    params => "" +
      "Studio Offering",

    // `filters-studio-activities-indoor-activity`:
    // Indoors at the studio
    params => "" +
      "Indoors at the studio",

    // `filters-studio-activities-livestream`:
    // Online Live
    params => "" +
      "Online Live",

    // `filters-studio-activities-outdoor-activity`:
    // Outdoors
    params => "" +
      "Outdoors",

    // `filters-studio-activities-video`:
    // Videos
    params => "" +
      "Videos",

    // `filters-studio-all-selected`:
    // All
    params => "" +
      "All",

    // `filters-studio-attributes-corporate-discount`:
    // Corporate Deals
    params => "" +
      "Corporate Deals",

    // `filters-studio-attributes-free-trial`:
    // Free Trial
    params => "" +
      "Free Trial",

    // `filters-studio-attributes-heading`:
    // Trial offers and deals
    params => "" +
      "Trial offers and deals",

    // `filters-studio-attributes-intro-offer`:
    // Newcomer deals
    params => "" +
      "Newcomer deals",

    // `filters-studio-attributes-new-venue`:
    // New on Eversports
    params => "" +
      "New on Eversports",

    // `filters-sub-sports-heading`:
    // Subcategory
    params => "" +
      "Subcategory",

    // `filters-sub-sports-search-label`:
    // Search
    params => "" +
      "Search",

    // `find-corporate-deals-on-venue-profile`:
    // Or you can search for your favorite venue and see if they have the orange corporate logo on their venue profile.
    // 
    params => "" +
      "Or you can search for your favorite venue and see if they have the orange corporate logo on their venue profile.\n",

    // `find-friends-section-sub-title`:
    // Use the search, share your profile-link, or sync your contacts on the apps
    params => "" +
      "Use the search, share your profile-link, or sync your contacts on the apps",

    // `find-friends-section-title`:
    // Find new friends
    params => "" +
      "Find new friends",

    // `find-friends-tab`:
    // Find friends
    params => "" +
      "Find friends",

    // `find-new-friends-search-placeholder`:
    // Search names or @usernames
    params => "" +
      "Search names or @usernames",

    // `find-new-friends-title`:
    // Search and add new friends
    params => "" +
      "Search and add new friends",

    // `fitness`:
    // Fitness
    params => "" +
      "Fitness",

    // `footer-about-us`:
    // About us
    params => "" +
      "About us",

    // `footer-accepted-payment-method`:
    // {paymentMethod} is an accepted form of payment
    params => "" +
      params.paymentMethod +
      " is an accepted form of payment",

    // `footer-blog`:
    // Blog
    params => "" +
      "Blog",

    // `footer-cancel-membership`:
    // Cancel a membership
    params => "" +
      "Cancel a membership",

    // `footer-career`:
    // Careers
    params => "" +
      "Careers",

    // `footer-contact-us`:
    // Contact us
    params => "" +
      "Contact us",

    // `footer-cookie-settings`:
    // Cookie Settings
    params => "" +
      "Cookie Settings",

    // `footer-copyright-disclaimer`:
    // {currentYear} Eversports GmbH. All rights reserved.
    params => "" +
      params.currentYear +
      " Eversports GmbH. All rights reserved.",

    // `footer-corporate-description`:
    // Then check out the benefits of Eversports Corporate now!
    params => "" +
      "Then check out the benefits of Eversports Corporate now!",

    // `footer-corporate-title`:
    // Do you work in HR?
    params => "" +
      "Do you work in HR?",

    // `footer-data-protection`:
    // Privacy Policy
    params => "" +
      "Privacy Policy",

    // `footer-demo`:
    // Get a free demo
    params => "" +
      "Get a free demo",

    // `footer-for-corporates`:
    // For companies
    params => "" +
      "For companies",

    // `footer-header-contact`:
    // Contact
    params => "" +
      "Contact",

    // `footer-header-eversports-manager`:
    // Eversports Manager
    params => "" +
      "Eversports Manager",

    // `footer-header-more-of-eversports`:
    // More about Eversports
    params => "" +
      "More about Eversports",

    // `footer-header-social-media`:
    // Social Media
    params => "" +
      "Social Media",

    // `footer-impressum`:
    // Impressum
    params => "" +
      "Impressum",

    // `footer-popular-sports-in-city`:
    // Popular sports in {cityName}
    params => "" +
      "Popular sports in " +
      params.cityName,

    // `footer-pricing`:
    // Pricing
    params => "" +
      "Pricing",

    // `footer-provider-description`:
    // Learn how we can accelerate your business. 
    params => "" +
      "Learn how we can accelerate your business. ",

    // `footer-provider-title`:
    // Venue Owner?
    params => "" +
      "Venue Owner?",

    // `footer-security`:
    // Security
    params => "" +
      "Security",

    // `footer-sport-in-city`:
    // {sportName} in {cityName}
    params => "" +
      params.sportName +
      " in " +
      params.cityName,

    // `footer-terms-and-conditions`:
    // Terms & Conditions
    params => "" +
      "Terms & Conditions",

    // `footer-visit-the-website`:
    // Visit the website
    params => "" +
      "Visit the website",

    // `forbidden-error-message`:
    // You are not allowed to access this page.
    params => "" +
      "You are not allowed to access this page.",

    // `forbidden-page-description`:
    // Sorry, you are not allowed to access this page.
    params => "" +
      "Sorry, you are not allowed to access this page.",

    // `forbidden-page-title`:
    // 403 - Forbidden
    params => "" +
      "403 - Forbidden",

    // `friend-request-badge`:
    // Requested
    params => "" +
      "Requested",

    // `friends`:
    // Friends
    params => "" +
      "Friends",

    // `friends-activities-tab`:
    // Activities
    params => "" +
      "Activities",

    // `friends-aria-label`:
    // Friends
    params => "" +
      "Friends",

    // `friends-attending-add-friends-learn-more`:
    // Learn more
    params => "" +
      "Learn more",

    // `friends-attending-promotion-advantage-1`:
    // 1. See each other’s upcoming activities
    params => "" +
      "1. See each other’s upcoming activities",

    // `friends-attending-promotion-advantage-2`:
    // 2. Find each other in your favorite venue’s schedule
    params => "" +
      "2. Find each other in your favorite venue’s schedule",

    // `friends-attending-promotion-advantage-3`:
    // 3. Easily schedule and enjoy sports together!
    params => "" +
      "3. Easily schedule and enjoy sports together!",

    // `friends-attending-promotion-button`:
    // Find your friends on Eversports now
    params => "" +
      "Find your friends on Eversports now",

    // `friends-attending-promotion-class-calendar-image-description`:
    // these friends are attending the activity
    params => "" +
      "these friends are attending the activity",

    // `friends-attending-promotion-profile-image-description`:
    // Add someone as a friend first to view their upcoming activities
    params => "" +
      "Add someone as a friend first to view their upcoming activities",

    // `friends-attending-promotion-subtitle`:
    // Start adding your friends on Eversports now to:
    params => "" +
      "Start adding your friends on Eversports now to:",

    // `friends-attending-promotion-text`:
    // Stay tuned for more new updates to the Friends feature that will be available on Eversports very soon!
    params => "" +
      "Stay tuned for more new updates to the Friends feature that will be available on Eversports very soon!",

    // `friends-attending-promotion-title`:
    // Do sports together with your friends!
    params => "" +
      "Do sports together with your friends!",

    // `friends-attending-section-title`:
    // These friends attend
    params => "" +
      "These friends attend",

    // `friends-button-text`:
    // Friends
    params => "" +
      "Friends",

    // `friends-count`:
    // {count} {count, plural, 
    // =1 {friend} 
    //  other {friends}}
    params => "" +
      formatter_0(params.count) +
      " " +
      (
        params.count == 1 ? "" +
          "friend" :
        "" +
          "friends"
      ),

    // `friends-of-user-title`:
    // {userFirstName}'s friends
    params => "" +
      params.userFirstName +
      "'s friends",

    // `friends-page-meta-description`:
    // Check your friends and your friend requests on Eversports
    params => "" +
      "Check your friends and your friend requests on Eversports",

    // `friends-page-meta-title`:
    // My Friends
    params => "" +
      "My Friends",

    // `friends-privacy-adjust-privacy-settings-link`:
    // adjust your privacy settings
    params => "" +
      "adjust your privacy settings",

    // `friends-privacy-update-confirmation-button`:
    // Accept and continue
    params => "" +
      "Accept and continue",

    // `friends-privacy-update-paragraph-1`:
    // In addition to booking sports activities, you can now connect with your friends on Eversports to easily find and book sports activities together!
    params => "" +
      "In addition to booking sports activities, you can now connect with your friends on Eversports to easily find and book sports activities together!",

    // `friends-privacy-update-paragraph-2`:
    // With your agreement to the new {privacyPolicyLink}, the following data will become visible to other users, which is necessary for you to be able to use the new function to its full extent:  Name, username, profile picture (if available), friends list.
    params => [
      "With your agreement to the new ",
      params.privacyPolicyLink,
      ", the following data will become visible to other users, which is necessary for you to be able to use the new function to its full extent:  Name, username, profile picture (if available), friends list.",
    ],

    // `friends-privacy-update-paragraph-3`:
    // If you change your mind later, or if you do not want this visibility, you can {privacySettingsLink} at any time according to your wishes: go to “Profile” → “Settings” → “Edit Profile Privacy” → “Hide profile”.
    params => [
      "If you change your mind later, or if you do not want this visibility, you can ",
      params.privacySettingsLink,
      " at any time according to your wishes: go to “Profile” → “Settings” → “Edit Profile Privacy” → “Hide profile”.",
    ],

    // `friends-privacy-update-paragraph-4`:
    // Since we are introducing customer profiles for all users, you will unfortunately no longer be able to use your current account without this consent.
    params => "" +
      "Since we are introducing customer profiles for all users, you will unfortunately no longer be able to use your current account without this consent.",

    // `friends-privacy-update-privacy-policy-link`:
    // privacy policy
    params => "" +
      "privacy policy",

    // `friends-privacy-update-title`:
    // Terms of Eversports
    params => "" +
      "Terms of Eversports",

    // `friends-requests-section-no-requests-description`:
    // Share your profile link with friends so they can add you.
    params => "" +
      "Share your profile link with friends so they can add you.",

    // `friends-requests-section-no-requests-title`:
    // You haven't received or sent any friend requests yet.
    params => "" +
      "You haven't received or sent any friend requests yet.",

    // `friends-requests-tab`:
    // Requests
    params => "" +
      "Requests",

    // `friends-section-title`:
    // My Friends {friendsCount, plural, 
    //  one {}=0 {} 
    //  other {({friendsCount})}}
    params => "" +
      "My Friends " +
      (
        context.p(params.friendsCount) == "one" ? "" :
        params.friendsCount == 0 ? "" :
        "" +
          "(" +
          formatter_0(params.friendsCount) +
          ")"
      ),

    // `friends-tab`:
    // All friends
    params => "" +
      "All friends",

    // `friendship-requested`:
    // Requested
    params => "" +
      "Requested",

    // `funktionelles-training`:
    // Functional Training
    params => "" +
      "Functional Training",

    // `fussball`:
    // Football
    params => "" +
      "Football",

    // `guest-disclaimer-section-button`:
    // Continue to register or login
    params => "" +
      "Continue to register or login",

    // `guest-disclaimer-section-description`:
    // Create a free Eversports account to accept match invitations and view the accepted booking in your profile!
    params => "" +
      "Create a free Eversports account to accept match invitations and view the accepted booking in your profile!",

    // `guest-disclaimer-section-title`:
    // Please log in or register to continue
    params => "" +
      "Please log in or register to continue",

    // `guest-join-match-button`:
    // Accept invitation
    params => "" +
      "Accept invitation",

    // `has-friends-notification-promotion-text`:
    // Want your friends to join you at your workout? When you share activities on Eversports, select which of your friends you would like to go with and they will be notified directly via Eversports!
    params => "" +
      "Want your friends to join you at your workout? When you share activities on Eversports, select which of your friends you would like to go with and they will be notified directly via Eversports!",

    // `has-friends-notification-promotion-title`:
    // Workout with friends!
    params => "" +
      "Workout with friends!",

    // `header-corporate-benefits-budget-left-amount`:
    // {hasMoreBudgetLabel} {availableBudget}
    params => "" +
      params.hasMoreBudgetLabel +
      " " +
      formatter_1(params.availableBudget),

    // `header-corporate-benefits-budget-left-label`:
    // Budget left:
    params => "" +
      "Budget left:",

    // `header-corporate-benefits-label`:
    // {corporatePartnerName} Benefits
    params => "" +
      params.corporatePartnerName +
      " Benefits",

    // `header-corporate-benefits-unlimited-budget`:
    // Unlimited budget
    params => "" +
      "Unlimited budget",

    // `header-for-businesses`:
    // For Sport Providers
    params => "" +
      "For Sport Providers",

    // `header-for-corporates`:
    // For companies
    params => "" +
      "For companies",

    // `header-logged-in-user`:
    // Welcome, {firstName}
    params => "" +
      "Welcome, " +
      params.firstName,

    // `header-login`:
    // Login
    params => "" +
      "Login",

    // `header-login-or-register`:
    // Login or Register
    params => "" +
      "Login or Register",

    // `header-register`:
    // Register
    params => "" +
      "Register",

    // `hiit`:
    // HIIT
    params => "" +
      "HIIT",

    // `home-brand-promise-1-description`:
    // Discover new classes, trainers and venues that match your everyday vibe.
    params => "" +
      "Discover new classes, trainers and venues that match your everyday vibe.",

    // `home-brand-promise-1-header`:
    // Find your perfect activity
    params => "" +
      "Find your perfect activity",

    // `home-brand-promise-2-description`:
    // Get a membership, drop-in, or anything in between. Easily choose your favorite product.
    params => "" +
      "Get a membership, drop-in, or anything in between. Easily choose your favorite product.",

    // `home-brand-promise-2-header`:
    // Stay flexible
    params => "" +
      "Stay flexible",

    // `home-brand-promise-3-description`:
    // Connect with other yoga and sports enthusiasts. It's more fun together!
    params => "" +
      "Connect with other yoga and sports enthusiasts. It's more fun together!",

    // `home-brand-promise-3-header`:
    // Stay motivated
    params => "" +
      "Stay motivated",

    // `home-cant-find-what-youre-looking-for`:
    // Can't find the offers you're looking for?
    params => "" +
      "Can't find the offers you're looking for?",

    // `home-city-sport-seo-links-card-header`:
    // Popular sports in {city}
    params => "" +
      "Popular sports in " +
      params.city,

    // `home-city-sport-seo-links-description`:
    // Whatever you choose, we have the right offer for you.
    params => "" +
      "Whatever you choose, we have the right offer for you.",

    // `home-city-sport-seo-links-header`:
    // Stay motivated, whether in online classes or on-site at the studio
    params => "" +
      "Stay motivated, whether in online classes or on-site at the studio",

    // `home-do-you-own-a-venue-thats-not-on-eversports`:
    // Do you own a sports venue and you are not seeing your classes here?
    params => "" +
      "Do you own a sports venue and you are not seeing your classes here?",

    // `home-download-the-eversports-app`:
    // Download the Eversports App
    params => "" +
      "Download the Eversports App",

    // `home-feature-preview-description`:
    // These cool features help you to stay motivated and keep you moving even on challenging days.
    // 
    params => "" +
      "These cool features help you to stay motivated and keep you moving even on challenging days.\n",

    // `home-feature-preview-friends-feed-description`:
    // Not only can you add friends on Eversports, you can invite each other to activities and also see which activities your friends have booked and join in directly. Let's go!
    params => "" +
      "Not only can you add friends on Eversports, you can invite each other to activities and also see which activities your friends have booked and join in directly. Let's go!",

    // `home-feature-preview-friends-feed-title`:
    // Stay connected with friends
    params => "" +
      "Stay connected with friends",

    // `home-feature-preview-header`:
    // Want to stay motivated? 
    params => "" +
      "Want to stay motivated? ",

    // `home-feature-preview-updates-description`:
    // To give you the best experience, we are constantly working on new features! We add 2-3 new features every month. Stay tuned!
    params => "" +
      "To give you the best experience, we are constantly working on new features! We add 2-3 new features every month. Stay tuned!",

    // `home-feature-preview-updates-title`:
    // Stay up to date
    params => "" +
      "Stay up to date",

    // `home-feature-preview-waiting-list-description`:
    // Join the waiting list for the class, workshop or event you would like to attend and be notified immediately when a spot becomes available.
    params => "" +
      "Join the waiting list for the class, workshop or event you would like to attend and be notified immediately when a spot becomes available.",

    // `home-feature-preview-waiting-list-title`:
    // Fully booked? No problem!
    params => "" +
      "Fully booked? No problem!",

    // `home-header`:
    // Book your favorite Sport, Fitness and Yoga activities
    params => "" +
      "Book your favorite Sport, Fitness and Yoga activities",

    // `home-header-focus-cities`:
    // Sport activities close to you
    params => "" +
      "Sport activities close to you",

    // `home-header-focus-sports`:
    // Book your favorite sports
    params => "" +
      "Book your favorite sports",

    // `home-header-online-offerings`:
    // Join your favorite studios from anywhere
    params => "" +
      "Join your favorite studios from anywhere",

    // `home-hero-image-alt-text`:
    // Athletes playing sports
    params => "" +
      "Athletes playing sports",

    // `home-label`:
    // Home
    params => "" +
      "Home",

    // `home-learn-about-the-manager`:
    // Learn about the Eversports Manager
    params => "" +
      "Learn about the Eversports Manager",

    // `home-learn-more`:
    // Learn More
    params => "" +
      "Learn More",

    // `home-live-online-button`:
    // Live Online Classes
    params => "" +
      "Live Online Classes",

    // `home-live-online-description`:
    // Train and practice with your favorite studios live and online from anywhere
    params => "" +
      "Train and practice with your favorite studios live and online from anywhere",

    // `home-live-online-title`:
    // Studio Live Online Classes
    params => "" +
      "Studio Live Online Classes",

    // `home-meta-description`:
    // On Eversports you will find all the studios and sports facilities in your area. Search for courses, workshops, events and sports fields that fit you and book easily online.
    params => "" +
      "On Eversports you will find all the studios and sports facilities in your area. Search for courses, workshops, events and sports fields that fit you and book easily online.",

    // `home-meta-title`:
    // Eversports - Your click to sport
    params => "" +
      "Eversports - Your click to sport",

    // `home-on-demand-button`:
    // Video On Demand
    params => "" +
      "Video On Demand",

    // `home-on-demand-description`:
    // Find replays of regular classes, or custom videos from the best studios, teachers, and trainers all across Europe
    params => "" +
      "Find replays of regular classes, or custom videos from the best studios, teachers, and trainers all across Europe",

    // `home-on-demand-title`:
    // On-Demand Classes
    params => "" +
      "On-Demand Classes",

    // `home-provider-promo-description`:
    // Discover how to showcase your offers on Eversports
    params => "" +
      "Discover how to showcase your offers on Eversports",

    // `home-provider-promo-title`:
    // Do you have your own studio or sports facility?
    params => "" +
      "Do you have your own studio or sports facility?",

    // `home-rebrand-all-sports-in-my-city`:
    // All sports in my city
    params => "" +
      "All sports in my city",

    // `home-rebrand-check-out-offerings-for`:
    // Check out offerings for
    params => "" +
      "Check out offerings for",

    // `home-rebrand-download-app-description`:
    // Download the Eversports app and keep track of all your favorite studios, classes, instructors, friends and bookings.
    params => "" +
      "Download the Eversports app and keep track of all your favorite studios, classes, instructors, friends and bookings.",

    // `home-rebrand-download-app-title`:
    // Everything in One Place
    params => "" +
      "Everything in One Place",

    // `home-rebrand-header`:
    // Book your yoga and sports activities now, let's go!
    params => "" +
      "Book your yoga and sports activities now, let's go!",

    // `home-rebrand-no-offerings`:
    // No offerings found. Please try another city and sport selection.
    params => "" +
      "No offerings found. Please try another city and sport selection.",

    // `home-rebrand-select-a-city`:
    // Select a city
    params => "" +
      "Select a city",

    // `home-rebrand-select-a-sport`:
    // Select a sport
    params => "" +
      "Select a sport",

    // `home-rebrand-sport-offerings-description`:
    // Grab your sports buddy and check out the latest trial offers near you.
    params => "" +
      "Grab your sports buddy and check out the latest trial offers near you.",

    // `home-rebrand-sport-offerings-header`:
    // Want to try something new?
    params => "" +
      "Want to try something new?",

    // `home-rebrand-subheader`:
    // Stay flexible and book your activities when and how it suits you best.
    params => "" +
      "Stay flexible and book your activities when and how it suits you best.",

    // `home-rebrand-testimonials-description`:
    // Hear what real Eversports users have to say about their experience with the App and Website. 
    params => "" +
      "Hear what real Eversports users have to say about their experience with the App and Website. ",

    // `home-rebrand-testimonials-header`:
    // What does the community say?
    params => "" +
      "What does the community say?",

    // `home-register-to-learn-about-the-manager`:
    // Register with Eversports Manager and get your activities listed today!
    params => "" +
      "Register with Eversports Manager and get your activities listed today!",

    // `home-sport-activities-in-city`:
    // Sport activities in {cityName}
    params => "" +
      "Sport activities in " +
      params.cityName,

    // `home-stay-active-and-book-sports`:
    // Stay active on the go by booking sports and purchasing memberships or block cards all in one place
    params => "" +
      "Stay active on the go by booking sports and purchasing memberships or block cards all in one place",

    // `home-subheader`:
    // Discover thousands of classes, workshops, and courts in your city
    params => "" +
      "Discover thousands of classes, workshops, and courts in your city",

    // `home-subheader-focus-cities`:
    // Find studios and sport venues in your favorite cities
    params => "" +
      "Find studios and sport venues in your favorite cities",

    // `home-subheader-focus-sports`:
    // One account for booking all your sports
    params => "" +
      "One account for booking all your sports",

    // `home-subheader-online-offerings`:
    // Live stream online classes, or explore video on demand
    params => "" +
      "Live stream online classes, or explore video on demand",

    // `home-suggest-a-venue`:
    // Suggest a venue to Eversports
    params => "" +
      "Suggest a venue to Eversports",

    // `home-suggest-a-venue-and-receive-a-voucher`:
    // Suggest a sport venue and earn up to 100 € (or 100 CHF) in Eversports vouchers
    params => "" +
      "Suggest a sport venue and earn up to 100 € (or 100 CHF) in Eversports vouchers",

    // `home-tld-meta-description`:
    // Find sport studios and facilities throughout {countryName}. Search for courses, workshops, events and sports fields that fit you and book easily online.
    params => "" +
      "Find sport studios and facilities throughout " +
      params.countryName +
      ". Search for courses, workshops, events and sports fields that fit you and book easily online.",

    // `home-tld-meta-title`:
    // Eversports - {countryName} - Your click to sport
    params => "" +
      "Eversports - " +
      params.countryName +
      " - Your click to sport",

    // `home-view-on-map`:
    // View on map
    params => "" +
      "View on map",

    // `home-what-is-eversports-description`:
    // With Eversports you have everything at a glance - your favorite activities, courses, events and workshops. Not only can you find the activity that suit you, you can also easily book all the offers in your area and connect with other people who love yoga and sports as much as you do.
    params => "" +
      "With Eversports you have everything at a glance - your favorite activities, courses, events and workshops. Not only can you find the activity that suit you, you can also easily book all the offers in your area and connect with other people who love yoga and sports as much as you do.",

    // `home-what-is-eversports-header`:
    // What you can expect at Eversports
    params => "" +
      "What you can expect at Eversports",

    // `home-where-is-eversports-description`:
    // Discover all the yoga and sports offers in your area and find out which studio or sports venue matches your vibe.
    params => "" +
      "Discover all the yoga and sports offers in your area and find out which studio or sports venue matches your vibe.",

    // `home-where-is-eversports-header`:
    // Your favorite sport in your city
    params => "" +
      "Your favorite sport in your city",

    // `homepage-my-friends-button`:
    // Friends
    params => "" +
      "Friends",

    // `in-city-label`:
    // in {cityName}
    params => "" +
      "in " +
      params.cityName,

    // `info-tool-tip-alt-text`:
    // See more information
    params => "" +
      "See more information",

    // `invite-friends-load-more`:
    // Load more friends
    params => "" +
      "Load more friends",

    // `invite-friends-no-friends-button`:
    // Start finding friends on Eversports
    params => "" +
      "Start finding friends on Eversports",

    // `invite-friends-no-friends-description`:
    // When you share bookings, activities and profiles with friends, they will receive a notification directly on Eversports!
    params => "" +
      "When you share bookings, activities and profiles with friends, they will receive a notification directly on Eversports!",

    // `invite-friends-no-friends-title`:
    // Share with friends with in-app notifications
    params => "" +
      "Share with friends with in-app notifications",

    // `invite-friends-send-notification-button`:
    // Send notification
    params => "" +
      "Send notification",

    // `invite-friends-title`:
    // Send on Eversports (friends will be notified)
    params => "" +
      "Send on Eversports (friends will be notified)",

    // `invoice-history-page-header`:
    // Invoice history
    params => "" +
      "Invoice history",

    // `invoice-history-table-header-date`:
    // Date
    params => "" +
      "Date",

    // `invoice-history-table-header-download-invoices`:
    // Download Invoices
    params => "" +
      "Download Invoices",

    // `invoice-history-table-header-payment-amount`:
    // Amount
    params => "" +
      "Amount",

    // `invoice-history-table-header-payment-method`:
    // Payment Method
    params => "" +
      "Payment Method",

    // `invoice-history-table-header-payment-status`:
    // Status
    params => "" +
      "Status",

    // `invoice-history-table-text-no-invoices`:
    // No invoices available
    params => "" +
      "No invoices available",

    // `invoice-status-cancelled`:
    // Cancelled
    params => "" +
      "Cancelled",

    // `invoice-status-paid`:
    // Paid
    params => "" +
      "Paid",

    // `invoice-status-refunded`:
    // Refunded
    params => "" +
      "Refunded",

    // `invoice-status-unpaid`:
    // Unpaid
    params => "" +
      "Unpaid",

    // `joined-match-disclaimer-bookings-link-text`:
    // Your bookings
    params => "" +
      "Your bookings",

    // `joined-match-disclaimer-button`:
    // Continue
    params => "" +
      "Continue",

    // `joined-match-disclaimer-description`:
    // You’ll get notified of updates and can check the status of this match from {bookingsLink} page. (Your match participation is publicly visible.)
    params => [
      "You’ll get notified of updates and can check the status of this match from ",
      params.bookingsLink,
      " page. (Your match participation is publicly visible.)",
    ],

    // `joined-match-disclaimer-title`:
    // You successfully joined
    params => "" +
      "You successfully joined",

    // `learn-more-about-eversports-corporate`:
    // Learn more about the Eversports Corporate Program
    params => "" +
      "Learn more about the Eversports Corporate Program",

    // `list-toggle-button`:
    // Show list
    params => "" +
      "Show list",

    // `listing-overview-classes`:
    // Classes
    params => "" +
      "Classes",

    // `listing-overview-currently-viewing`:
    // Currently viewing
    params => "" +
      "Currently viewing",

    // `listing-overview-more`:
    // More
    params => "" +
      "More",

    // `listing-overview-studios`:
    // Studios
    params => "" +
      "Studios",

    // `listing-result-count`:
    // {count} found within current map
    params => "" +
      formatter_0(params.count) +
      " found within current map",

    // `listing-result-online-only-venue`:
    // Online
    params => "" +
      "Online",

    // `livestreams-offering-heading`:
    // Livestreams
    params => "" +
      "Livestreams",

    // `load-more`:
    // Load more
    params => "" +
      "Load more",

    // `load-more-friends-button`:
    // Load more
    params => "" +
      "Load more",

    // `load-more-notifications-button`:
    // Load more
    params => "" +
      "Load more",

    // `load-more-suggestions`:
    // Load more
    params => "" +
      "Load more",

    // `load-more-upcoming-friends-participations-button`:
    // Load more
    params => "" +
      "Load more",

    // `location-on-map-alt-text`:
    // Location on map
    params => "" +
      "Location on map",

    // `logged-in-user-join-match-button`:
    // Yes, I'll join the match
    params => "" +
      "Yes, I'll join the match",

    // `logged-in-user-match-disclaimer-dont-forget`:
    // Will you join?
    params => "" +
      "Will you join?",

    // `logged-in-user-match-disclaimer-subtitle`:
    // Help organizing the match by joining and enjoy some sports together!
    params => "" +
      "Help organizing the match by joining and enjoy some sports together!",

    // `logged-in-user-match-disclaimer-title`:
    // Join, so {organizerFirstName} knows you're in!
    params => "" +
      "Join, so " +
      params.organizerFirstName +
      " knows you're in!",

    // `login-or-register-disclaimer-description`:
    // {descriptionType, select, 
    //  joining-a-match {Create a free Eversports account to accept match invitations and view the accepted booking in your profile!} 
    //  favoriting-venue {Create a free Eversports account to be able to add venues to your favorites!} 
    //  adding-a-friend {Create a free Eversports account to be able to add friends!} 
    //  other {Create a free Eversports account to be able to continue!}}
    params => "" +
      (
        params.descriptionType == "joining-a-match" ? "" +
          "Create a free Eversports account to accept match invitations and view the accepted booking in your profile!" :
        params.descriptionType == "favoriting-venue" ? "" +
          "Create a free Eversports account to be able to add venues to your favorites!" :
        params.descriptionType == "adding-a-friend" ? "" +
          "Create a free Eversports account to be able to add friends!" :
        "" +
          "Create a free Eversports account to be able to continue!"
      ),

    // `manager-promo-button-text`:
    // Eversports Manager
    params => "" +
      "Eversports Manager",

    // `manager-promo-subtitle`:
    // Your intuitive online booking system.
    params => "" +
      "Your intuitive online booking system.",

    // `manager-promo-title`:
    // Bring your offers to Eversports!
    params => "" +
      "Bring your offers to Eversports!",

    // `map-geolocation-not-found-error-message`:
    // Location could not be determined. Please enable location sharing for this website in your browser settings.
    params => "" +
      "Location could not be determined. Please enable location sharing for this website in your browser settings.",

    // `map-toggle-button`:
    // Show map
    params => "" +
      "Show map",

    // `match-additional-actions-options`:
    // Options
    params => "" +
      "Options",

    // `match-booking-page-title`:
    // Booking Information
    params => "" +
      "Booking Information",

    // `match-court-area-indoor`:
    // Indoor
    params => "" +
      "Indoor",

    // `match-court-area-outdoor`:
    // Outdoor
    params => "" +
      "Outdoor",

    // `match-court-surface-type-artificial-grass`:
    // Artificial Grass
    params => "" +
      "Artificial Grass",

    // `match-court-surface-type-artificial-ice`:
    // Artificial Ice
    params => "" +
      "Artificial Ice",

    // `match-court-surface-type-ash`:
    // Ash
    params => "" +
      "Ash",

    // `match-court-surface-type-asphalt`:
    // Asphalt
    params => "" +
      "Asphalt",

    // `match-court-surface-type-carpet`:
    // Carpet
    params => "" +
      "Carpet",

    // `match-court-surface-type-carpet-granule`:
    // Carpet Granule
    params => "" +
      "Carpet Granule",

    // `match-court-surface-type-concrete`:
    // Concrete
    params => "" +
      "Concrete",

    // `match-court-surface-type-felt`:
    // Felt
    params => "" +
      "Felt",

    // `match-court-surface-type-granuale`:
    // Granuale
    params => "" +
      "Granuale",

    // `match-court-surface-type-grass`:
    // Grass
    params => "" +
      "Grass",

    // `match-court-surface-type-hard-court`:
    // Hard Court
    params => "" +
      "Hard Court",

    // `match-court-surface-type-ice`:
    // Ice
    params => "" +
      "Ice",

    // `match-court-surface-type-opticourt`:
    // Opticourt
    params => "" +
      "Opticourt",

    // `match-court-surface-type-parquet`:
    // Parquet
    params => "" +
      "Parquet",

    // `match-court-surface-type-pvc`:
    // PVC
    params => "" +
      "PVC",

    // `match-court-surface-type-red-court`:
    // Red Court
    params => "" +
      "Red Court",

    // `match-court-surface-type-sand`:
    // Sand
    params => "" +
      "Sand",

    // `match-court-surface-type-synthetic`:
    // Synthetic
    params => "" +
      "Synthetic",

    // `match-court-surface-type-tartan`:
    // Tartan
    params => "" +
      "Tartan",

    // `match-court-surface-type-water`:
    // Water
    params => "" +
      "Water",

    // `match-duration-in-minutes-short`:
    // {duration} min
    params => "" +
      formatter_0(params.duration) +
      " min",

    // `match-is-full`:
    // Match already full
    params => "" +
      "Match already full",

    // `match-not-found-call-to-action`:
    // Go back to Home
    params => "" +
      "Go back to Home",

    // `match-overview-banner-subtitle`:
    // Thank you for using eversports
    params => "" +
      "Thank you for using eversports",

    // `match-overview-banner-title`:
    // {sportName} booking information
    params => "" +
      params.sportName +
      " booking information",

    // `match-participants-count`:
    // Current players ({count})
    params => "" +
      "Current players (" +
      formatter_0(params.count) +
      ")",

    // `match-participants-with-count-with-max-participants`:
    // Current players ({current}/{max})
    params => "" +
      "Current players (" +
      formatter_0(params.current) +
      "/" +
      formatter_0(params.max) +
      ")",

    // `match-participation-remove-button`:
    // Remove me
    params => "" +
      "Remove me",

    // `match-participation-successful-message`:
    // You have joined this match
    params => "" +
      "You have joined this match",

    // `match-promotion-advantage-1`:
    // • join the match and inform all players they're in
    params => "" +
      "• join the match and inform all players they're in",

    // `match-promotion-advantage-2`:
    // • view the court booking details in their profile
    params => "" +
      "• view the court booking details in their profile",

    // `match-promotion-advantage-3`:
    // • stay updated via push notifications
    params => "" +
      "• stay updated via push notifications",

    // `match-promotion-advantages-title`:
    // Did you know that you can easily fill your match with players by...
    params => "" +
      "Did you know that you can easily fill your match with players by...",

    // `match-promotion-confirmation-button`:
    // Got it!
    params => "" +
      "Got it!",

    // `match-refund-message`:
    // Your booking has been cancelled. Your payment will be refunded within 2-3 working days
    params => "" +
      "Your booking has been cancelled. Your payment will be refunded within 2-3 working days",

    // `match-rejected-message`:
    // Your booking was unfortunately declined by the provider. Your payment will be refunded within 2-3 business days.
    params => "" +
      "Your booking was unfortunately declined by the provider. Your payment will be refunded within 2-3 business days.",

    // `match-rule-competition-type-competitive`:
    // Competitive
    params => "" +
      "Competitive",

    // `match-rule-competition-type-competitive-description`:
    // The players play to win, keep track of the score, and look forward to a serious match.
    params => "" +
      "The players play to win, keep track of the score, and look forward to a serious match.",

    // `match-rule-competition-type-friendly`:
    // Friendly
    params => "" +
      "Friendly",

    // `match-rule-competition-type-friendly-description`:
    // No one's keeping a leaderboard and the players just want to have fun or freshen up their skills.
    params => "" +
      "No one's keeping a leaderboard and the players just want to have fun or freshen up their skills.",

    // `match-rule-competition-type-placeholder`:
    // Type
    params => "" +
      "Type",

    // `match-rule-competition-type-title`:
    // Type of match
    params => "" +
      "Type of match",

    // `match-rule-gender-female-only`:
    // Female
    params => "" +
      "Female",

    // `match-rule-gender-male-only`:
    // Male
    params => "" +
      "Male",

    // `match-rule-gender-placeholder`:
    // Gender
    params => "" +
      "Gender",

    // `match-rule-gender-title`:
    // Player gender
    params => "" +
      "Player gender",

    // `match-rule-gender-unisex`:
    // All
    params => "" +
      "All",

    // `match-rule-level-advanced`:
    // Advanced
    params => "" +
      "Advanced",

    // `match-rule-level-advanced-description`:
    // The players are in control of the game and play at a high level, they are able to defend well, and enjoy a sweaty match.
    params => "" +
      "The players are in control of the game and play at a high level, they are able to defend well, and enjoy a sweaty match.",

    // `match-rule-level-any`:
    // Any Level
    params => "" +
      "Any Level",

    // `match-rule-level-any-description`:
    // Players of all levels are welcome to join the match.
    params => "" +
      "Players of all levels are welcome to join the match.",

    // `match-rule-level-beginner`:
    // Beginner
    params => "" +
      "Beginner",

    // `match-rule-level-beginner-description`:
    // The players have never played or only for a few times and cannot keep the ball in play for long.
    params => "" +
      "The players have never played or only for a few times and cannot keep the ball in play for long.",

    // `match-rule-level-intermediate`:
    // Intermediate
    params => "" +
      "Intermediate",

    // `match-rule-level-intermediate-description`:
    // The players have never played or only for a few times and cannot keep the ball in play for long.
    params => "" +
      "The players have never played or only for a few times and cannot keep the ball in play for long.",

    // `match-rule-level-placeholder`:
    // Level
    params => "" +
      "Level",

    // `match-rule-level-title`:
    // Required level
    params => "" +
      "Required level",

    // `match-rule-max-number-of-players`:
    // Maximum required no. of players
    params => "" +
      "Maximum required no. of players",

    // `match-rules-call-to-action`:
    // {desiredVisibility, select, 
    //  PUBLIC {Save & Publish} 
    //  PRIVATE {Save & Continue} 
    //  other {Save & Continue}}
    params => "" +
      (
        params.desiredVisibility == "PUBLIC" ? "" +
          "Save & Publish" :
        params.desiredVisibility == "PRIVATE" ? "" +
          "Save & Continue" :
        "" +
          "Save & Continue"
      ),

    // `match-rules-fill-out-required-fields`:
    // Fill out all required fields
    params => "" +
      "Fill out all required fields",

    // `match-sharing-message`:
    // Hey, I've booked {sportName} on Eversports for us: 
    //  
    //  📅 {dayOfTheWeek}, {formattedDate} 
    //  ⏰ {startTime} - {endTime} ({duration} min) 
    //  🏠 {venueName} 
    //  
    //  ➡️ Let me know if you're in by joining here: {matchUrl}
    params => "" +
      "Hey, I've booked " +
      params.sportName +
      " on Eversports for us: \n \n 📅 " +
      params.dayOfTheWeek +
      ", " +
      params.formattedDate +
      " \n ⏰ " +
      params.startTime +
      " - " +
      params.endTime +
      " (" +
      formatter_0(params.duration) +
      " min) \n 🏠 " +
      params.venueName +
      " \n \n ➡️ Let me know if you're in by joining here: " +
      params.matchUrl,

    // `match-thank-you-banner-subtitle-booking-confirmed`:
    // Thank you for using Eversports
    params => "" +
      "Thank you for using Eversports",

    // `match-thank-you-banner-subtitle-booking-rejected`:
    // De locatie heeft je boeking afgewezen
    params => "" +
      "De locatie heeft je boeking afgewezen",

    // `match-thank-you-banner-subtitle-booking-requested`:
    // You will receive an email as soon as your request is confirmed by the provider
    params => "" +
      "You will receive an email as soon as your request is confirmed by the provider",

    // `match-thank-you-banner-title-booking-cancelled`:
    // Booking Cancelled
    params => "" +
      "Booking Cancelled",

    // `match-thank-you-banner-title-booking-confirmed`:
    // Booking Successful
    params => "" +
      "Booking Successful",

    // `match-thank-you-banner-title-booking-planned`:
    // Thank you for your booking
    params => "" +
      "Thank you for your booking",

    // `match-thank-you-banner-title-booking-rejected`:
    // Rejected by Venue
    params => "" +
      "Rejected by Venue",

    // `match-thank-you-banner-title-booking-requested`:
    // Pending Request
    params => "" +
      "Pending Request",

    // `match-thank-you-page-title`:
    // Thank You
    params => "" +
      "Thank You",

    // `match-visibility-badge-private`:
    // Private
    params => "" +
      "Private",

    // `match-visibility-badge-public`:
    // Public
    params => "" +
      "Public",

    // `match-visibility-toggle-label`:
    // {visibility, select, 
    //  PUBLIC {Public} 
    //  PRIVATE {Private} 
    //  other {Private}}
    params => "" +
      (
        params.visibility == "PUBLIC" ? "" +
          "Public" :
        params.visibility == "PRIVATE" ? "" +
          "Private" :
        "" +
          "Private"
      ),

    // `match-visibility-toggle-label-subtitle`:
    // {visibility, select, 
    //  PUBLIC {List on Eversports} 
    //  PRIVATE {only visible with link} 
    //  other {only visible with link}}
    params => "" +
      (
        params.visibility == "PUBLIC" ? "" +
          "List on Eversports" :
        params.visibility == "PRIVATE" ? "" +
          "only visible with link" :
        "" +
          "only visible with link"
      ),

    // `meditation`:
    // Meditation
    params => "" +
      "Meditation",

    // `mobile-filters-apply-filters`:
    // Apply Filters
    params => "" +
      "Apply Filters",

    // `mobile-filters-cancel`:
    // Cancel
    params => "" +
      "Cancel",

    // `mobile-filters-heading`:
    // Filter
    params => "" +
      "Filter",

    // `mobile-filters-reset`:
    // Reset
    params => "" +
      "Reset",

    // `mobile-filters-toggle-button`:
    // Filter
    params => "" +
      "Filter",

    // `month-of-the-year`:
    // {month, select, 
    //  1 {January} 
    //  2 {February} 
    //  3 {March} 
    //  4 {April} 
    //  5 {May} 
    //  6 {June} 
    //  7 {July} 
    //  8 {August} 
    //  9 {September} 
    //  10 {October} 
    //  11 {November} 
    //  12 {December} 
    //  other {}}
    params => "" +
      (
        params.month == "1" ? "" +
          "January" :
        params.month == "2" ? "" +
          "February" :
        params.month == "3" ? "" +
          "March" :
        params.month == "4" ? "" +
          "April" :
        params.month == "5" ? "" +
          "May" :
        params.month == "6" ? "" +
          "June" :
        params.month == "7" ? "" +
          "July" :
        params.month == "8" ? "" +
          "August" :
        params.month == "9" ? "" +
          "September" :
        params.month == "10" ? "" +
          "October" :
        params.month == "11" ? "" +
          "November" :
        params.month == "12" ? "" +
          "December" :
        ""
      ),

    // `more-slots-label`:
    // + more
    params => "" +
      "+ more",

    // `navigation-tab-new-tag`:
    // New
    params => "" +
      "New",

    // `next`:
    // Continue
    params => "" +
      "Continue",

    // `next-page-label`:
    // Next page
    params => "" +
      "Next page",

    // `no`:
    // No
    params => "" +
      "No",

    // `no-comments-placeholder-text`:
    // No comments yet
    params => "" +
      "No comments yet",

    // `no-friends-notification-promotion-text`:
    // Receive notifications such as friend requests, invitations from your friends to activities and matches, or when they share their bookings with you. Don't have any friends on Eversports yet? Then start your search now.
    params => "" +
      "Receive notifications such as friend requests, invitations from your friends to activities and matches, or when they share their bookings with you. Don't have any friends on Eversports yet? Then start your search now.",

    // `no-friends-notification-promotion-title`:
    // Stay up to date
    params => "" +
      "Stay up to date",

    // `no-friends-upcoming-participations-add-friends-button`:
    // Add friends
    params => "" +
      "Add friends",

    // `no-friends-upcoming-participations-description`:
    // Browse the activities your friends booked and enjoy doing sports together!
    params => "" +
      "Browse the activities your friends booked and enjoy doing sports together!",

    // `no-friends-upcoming-participations-invite-to-bookings-button`:
    // Invite friends to an activity
    params => "" +
      "Invite friends to an activity",

    // `no-friends-upcoming-participations-title`:
    // All upcoming activities of your friends at one glance
    params => "" +
      "All upcoming activities of your friends at one glance",

    // `no-matches-found`:
    // No matches found for your filters. Please adapt them and try again.
    params => "" +
      "No matches found for your filters. Please adapt them and try again.",

    // `no-matches-found-description`:
    // Change your filters or create a match yourself!
    params => "" +
      "Change your filters or create a match yourself!",

    // `no-matches-found-title`:
    // There are unfortunately no public matches available at the moment
    params => "" +
      "There are unfortunately no public matches available at the moment",

    // `no-matches-how-to-create-a-public-match`:
    // How to create a public match
    params => "" +
      "How to create a public match",

    // `no-matches-view-court-schedule`:
    // Go to court schedule
    params => "" +
      "Go to court schedule",

    // `no-notifications-description`:
    // Here you can see all notifications when your friends e.g. share activities and venues, or invite you to their bookings.
    params => "" +
      "Here you can see all notifications when your friends e.g. share activities and venues, or invite you to their bookings.",

    // `no-notifications-title`:
    // Send and receive notifications from your friends
    params => "" +
      "Send and receive notifications from your friends",

    // `no-number-of-players-set`:
    // Not set
    params => "" +
      "Not set",

    // `no-spots-left`:
    // Full
    params => "" +
      "Full",

    // `non-logged-in-user-comment-disclaimer`:
    // Please log in to be able to comment!
    params => "" +
      "Please log in to be able to comment!",

    // `not-found-page-description`:
    // Sorry, the page you are looking for does not exist.
    params => "" +
      "Sorry, the page you are looking for does not exist.",

    // `not-found-page-title`:
    // 404 - Page not found
    params => "" +
      "404 - Page not found",

    // `notification-banner-description`:
    // Now you can find and explore venues in your area even easier
    params => "" +
      "Now you can find and explore venues in your area even easier",

    // `notification-banner-title`:
    // Welcome to Eversports' new studio finder!
    params => "" +
      "Welcome to Eversports' new studio finder!",

    // `notification-center-tooltip-description`:
    // Find all updates and notifications in one place
    params => "" +
      "Find all updates and notifications in one place",

    // `notification-center-tooltip-title`:
    // New
    params => "" +
      "New",

    // `notification-promotion-dialog-add-friends`:
    // Add friends
    params => "" +
      "Add friends",

    // `notification-promotion-dialog-back`:
    // Back
    params => "" +
      "Back",

    // `notification-promotion-dialog-invite-friends`:
    // Share bookings with friends
    params => "" +
      "Share bookings with friends",

    // `notifications`:
    // Notifications
    params => "" +
      "Notifications",

    // `notifications-aria-label`:
    // Notifications
    params => "" +
      "Notifications",

    // `notifications-meta-description`:
    // Here you will find all of your latest notifications from Eversports
    params => "" +
      "Here you will find all of your latest notifications from Eversports",

    // `notifications-meta-title`:
    // Eversports - Notifications
    params => "" +
      "Eversports - Notifications",

    // `notifications-page-title`:
    // Notifications
    params => "" +
      "Notifications",

    // `nps-comment-button`:
    // Send
    params => "" +
      "Send",

    // `nps-comment-edit-score-button`:
    // Edit score
    params => "" +
      "Edit score",

    // `nps-comment-placeholder`:
    // Help us by explaining your score.
    params => "" +
      "Help us by explaining your score.",

    // `nps-comment-title`:
    // Thank you! Could you kindly tell us why?
    params => "" +
      "Thank you! Could you kindly tell us why?",

    // `nps-score-button`:
    // Continue
    params => "" +
      "Continue",

    // `nps-score-button-no-number-selected`:
    // Select a score
    params => "" +
      "Select a score",

    // `nps-score-extremely-likely`:
    // Extremely likely
    params => "" +
      "Extremely likely",

    // `nps-score-not-at-all-likely`:
    // Not at all likely
    params => "" +
      "Not at all likely",

    // `nps-score-thank-you-message`:
    // Thank you for your response, and your feedback!
    params => "" +
      "Thank you for your response, and your feedback!",

    // `nps-score-title`:
    // How likely are you to recommend Eversports to a friend or co-worker?
    params => "" +
      "How likely are you to recommend Eversports to a friend or co-worker?",

    // `number-of-listing-results-found`:
    // {count} results found
    params => "" +
      formatter_0(params.count) +
      " results found",

    // `number-of-open-spots`:
    // {openSpots, plural, =0 {Full}
    //  =1 {1 spot}
    //  other {{openSpots} spots}}
    params => "" +
      (
        params.openSpots == 0 ? "" +
          "Full" :
        params.openSpots == 1 ? "" +
          "1 spot" :
        "" +
          formatter_0(params.openSpots) +
          " spots"
      ),

    // `online-only-venue-description`:
    // Discover online live classes and videos at these studios
    params => "" +
      "Discover online live classes and videos at these studios",

    // `online-only-venue-heading`:
    // No matching studios in your area? Try one of these online studios
    params => "" +
      "No matching studios in your area? Try one of these online studios",

    // `only-bookable-14-days-ahead`:
    // Only bookable 14 days ahead
    params => "" +
      "Only bookable 14 days ahead",

    // `open-google-maps`:
    // Open Google Maps
    params => "" +
      "Open Google Maps",

    // `open-google-maps-short-text`:
    // Open Map
    params => "" +
      "Open Map",

    // `open-maps`:
    // Map
    params => "" +
      "Map",

    // `open-trainings-offering-heading`:
    // Open trainings
    params => "" +
      "Open trainings",

    // `organizer-match-disclaimer-next-step`:
    // Tip:
    params => "" +
      "Tip:",

    // `organizer-match-disclaimer-subtitle`:
    // Share the link or publish your match to find players on Eversports
    params => "" +
      "Share the link or publish your match to find players on Eversports",

    // `organizer-match-disclaimer-title`:
    // Increase chances for a successful match:
    params => "" +
      "Increase chances for a successful match:",

    // `organizer-note-placeholder`:
    // e.g. What should your co-players take with them? When and where is the meeting point? ...
    params => "" +
      "e.g. What should your co-players take with them? When and where is the meeting point? ...",

    // `organizer-note-subtitle-admin`:
    // Optional
    params => "" +
      "Optional",

    // `organizer-note-title-admin`:
    // Anything to tell your players?
    params => "" +
      "Anything to tell your players?",

    // `organizer-note-title-non-admin`:
    // Infos from the organizer
    params => "" +
      "Infos from the organizer",

    // `organizer-sharing-button`:
    // Share with friends
    params => "" +
      "Share with friends",

    // `overall-price`:
    // Overall price
    params => "" +
      "Overall price",

    // `padel`:
    // Padel
    params => "" +
      "Padel",

    // `pagination-page-label`:
    // Page
    params => "" +
      "Page",

    // `participant-match-disclaimer-all-set`:
    // All set:
    params => "" +
      "All set:",

    // `participant-match-disclaimer-subtitle`:
    // {organizerFirstName} is happy you’re joining and looks forward to the match.
    params => "" +
      params.organizerFirstName +
      " is happy you’re joining and looks forward to the match.",

    // `participant-match-disclaimer-title`:
    // You're part of the match and ready to play!
    params => "" +
      "You're part of the match and ready to play!",

    // `participation-rules-title`:
    // Match Settings
    params => "" +
      "Match Settings",

    // `participation-state-booked`:
    // Booked
    params => "" +
      "Booked",

    // `participation-state-joined`:
    // Joined
    params => "" +
      "Joined",

    // `payment_unit_euro`:
    // Euro
    params => "" +
      "Euro",

    // `payment-service-type-bancontact`:
    // Bancontact
    params => "" +
      "Bancontact",

    // `payment-service-type-cash`:
    // Cash
    params => "" +
      "Cash",

    // `payment-service-type-chequecard`:
    // Cheque Card
    params => "" +
      "Cheque Card",

    // `payment-service-type-chequevacance`:
    // Cheque Vacances
    params => "" +
      "Cheque Vacances",

    // `payment-service-type-credit`:
    // Credit
    params => "" +
      "Credit",

    // `payment-service-type-creditcard`:
    // Credit Card
    params => "" +
      "Credit Card",

    // `payment-service-type-creditcard-otc`:
    // Credit Card OTC
    params => "" +
      "Credit Card OTC",

    // `payment-service-type-debitcard`:
    // Debit Card
    params => "" +
      "Debit Card",

    // `payment-service-type-eps`:
    // EPS
    params => "" +
      "EPS",

    // `payment-service-type-giropay`:
    // GIROPAY
    params => "" +
      "GIROPAY",

    // `payment-service-type-ideal`:
    // iDeal
    params => "" +
      "iDeal",

    // `payment-service-type-manual`:
    // Manual
    params => "" +
      "Manual",

    // `payment-service-type-marketing-discount`:
    // Discount
    params => "" +
      "Discount",

    // `payment-service-type-paypal`:
    // Paypal
    params => "" +
      "Paypal",

    // `payment-service-type-sepa`:
    // SEPA
    params => "" +
      "SEPA",

    // `payment-service-type-sepa-online`:
    // SEPA Online
    params => "" +
      "SEPA Online",

    // `payment-service-type-sofort`:
    // SOFORT
    params => "" +
      "SOFORT",

    // `payment-service-type-transfer`:
    // Transfer
    params => "" +
      "Transfer",

    // `payment-service-type-twint`:
    // TWINT
    params => "" +
      "TWINT",

    // `payment-service-type-twint-otc`:
    // TWINT OTC
    params => "" +
      "TWINT OTC",

    // `payment-service-type-voucher`:
    // Voucher
    params => "" +
      "Voucher",

    // `payment-service-type-voucher-otc`:
    // Voucher OTC
    params => "" +
      "Voucher OTC",

    // `payment-state-open`:
    // Unpaid
    params => "" +
      "Unpaid",

    // `payment-state-succeeded`:
    // Paid online
    params => "" +
      "Paid online",

    // `payment-status-paid`:
    // Paid
    params => "" +
      "Paid",

    // `payment-status-unpaid`:
    // Unpaid
    params => "" +
      "Unpaid",

    // `pilates`:
    // Pilates
    params => "" +
      "Pilates",

    // `poledance`:
    // Pole Dance
    params => "" +
      "Pole Dance",

    // `previous-page-label`:
    // Previous page
    params => "" +
      "Previous page",

    // `price-per-player`:
    // {price} / player ({maxParticipants})
    params => [
      params.price,
      " / player (",
      formatter_0(params.maxParticipants),
      ")",
    ],

    // `privacy-setting-button-visibility`:
    // {visibility, select, 
    //  PRIVATE {Only me} 
    //  FRIEND {Only friends} 
    //  other {Public}}
    params => "" +
      (
        params.visibility == "PRIVATE" ? "" +
          "Only me" :
        params.visibility == "FRIEND" ? "" +
          "Only friends" :
        "" +
          "Public"
      ),

    // `private-match-toggled-snackbar-message`:
    // Your match is set to private and not visible for other users on Eversports anymore.
    params => "" +
      "Your match is set to private and not visible for other users on Eversports anymore.",

    // `private-profile-description`:
    // There is no information available
    params => "" +
      "There is no information available",

    // `private-profile-page-description`:
    // This profile is private.
    params => "" +
      "This profile is private.",

    // `private-profile-page-title`:
    // Private User Profile
    params => "" +
      "Private User Profile",

    // `private-profile-title`:
    // This profile is set to private
    params => "" +
      "This profile is set to private",

    // `profile-privacy-apply-button`:
    // Apply
    params => "" +
      "Apply",

    // `profile-privacy-dismiss-button`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `profile-privacy-hide-profile-description`:
    // By hiding your profile, no one can find or view your Eversports profile.
    params => "" +
      "By hiding your profile, no one can find or view your Eversports profile.",

    // `profile-privacy-hide-profile-text`:
    // Hide profile on Eversports
    params => "" +
      "Hide profile on Eversports",

    // `profile-privacy-settings-description`:
    // Who can find and view your profile
    params => "" +
      "Who can find and view your profile",

    // `profile-privacy-settings-title`:
    // Profile Privacy Settings
    params => "" +
      "Profile Privacy Settings",

    // `public-match-created-disclaimer-button`:
    // Got it!
    params => "" +
      "Got it!",

    // `public-match-created-disclaimer-description`:
    // {bookingState, select, 
    //  ACCEPTED {Your match is now visible on Eversports and other users can find it on {matchesLink}.} 
    //  REQUESTED {Once the venue has accepted your booking, your match will be visible on Eversports and other users can find it on {matchesLink}.} 
    //  other {}}
    params => [
      ...(
        params.bookingState == "ACCEPTED" ? [
          "Your match is now visible on Eversports and other users can find it on ",
          params.matchesLink,
          ".",
        ] :
        params.bookingState == "REQUESTED" ? [
          "Once the venue has accepted your booking, your match will be visible on Eversports and other users can find it on ",
          params.matchesLink,
          ".",
        ] :
        [
        ]
      ),
    ],

    // `public-match-created-disclaimer-matches-link-text`:
    // the matches overview
    params => "" +
      "the matches overview",

    // `public-match-created-disclaimer-title`:
    // You successfully created a public match!
    params => "" +
      "You successfully created a public match!",

    // `public-match-offering-heading`:
    // Public Matches
    params => "" +
      "Public Matches",

    // `public-matches-advantage-1`:
    // • Your friend cancels on short notice
    params => "" +
      "• Your friend cancels on short notice",

    // `public-matches-advantage-2`:
    // • You do not have enough players
    params => "" +
      "• You do not have enough players",

    // `public-matches-advantage-3`:
    // • You want to find new people to do sports with
    params => "" +
      "• You want to find new people to do sports with",

    // `public-matches-confirmation-button`:
    // Got it!
    params => "" +
      "Got it!",

    // `public-matches-price-per-player`:
    // {price} / person
    params => [
      params.price,
      " / person",
    ],

    // `public-matches-promotion-advantages-sub-title`:
    // Matches on Eversports can help you find players if
    params => "" +
      "Matches on Eversports can help you find players if",

    // `public-matches-promotion-advantages-title`:
    // Introducing Matches 🔥
    params => "" +
      "Introducing Matches 🔥",

    // `public-matches-section-title`:
    // {venueName} - Matches
    params => "" +
      params.venueName +
      " - Matches",

    // `public-user-profile-meta-description`:
    // Add your friends on Eversports and book your next sports activity together!
    params => "" +
      "Add your friends on Eversports and book your next sports activity together!",

    // `public-user-profile-meta-title`:
    // Check out {firstName}'s Profile on Eversports
    params => "" +
      "Check out " +
      params.firstName +
      "'s Profile on Eversports",

    // `rating-no-reviews`:
    // (No reviews yet)
    params => "" +
      "(No reviews yet)",

    // `rating-review-count`:
    // {rating} ({reviewCount} {reviewCount, plural, one {Review} other {Reviews}})
    params => "" +
      formatter_0(params.rating) +
      " (" +
      formatter_0(params.reviewCount) +
      " " +
      (
        context.p(params.reviewCount) == "one" ? "" +
          "Review" :
        "" +
          "Reviews"
      ) +
      ")",

    // `rating-type-atmosphere`:
    // Atmosphere
    params => "" +
      "Atmosphere",

    // `rating-type-cleanliness`:
    // Cleanliness
    params => "" +
      "Cleanliness",

    // `rating-type-friendliness-and-service`:
    // Friendliness & Service
    params => "" +
      "Friendliness & Service",

    // `rating-type-price-performance`:
    // Price Performance
    params => "" +
      "Price Performance",

    // `rating-type-room-quality`:
    // Room Quality
    params => "" +
      "Room Quality",

    // `received-friend-requests-title`:
    // Received ({count})
    params => "" +
      "Received (" +
      formatter_0(params.count) +
      ")",

    // `recent-teachers-header`:
    // Your recent trainers and teachers
    params => "" +
      "Your recent trainers and teachers",

    // `recent-teachers-placeholder`:
    // Join more studios and activities to see more teachers here
    params => "" +
      "Join more studios and activities to see more teachers here",

    // `recent-teachers-sub-header`:
    // Teachers and trainers of activities you've recently joined
    params => "" +
      "Teachers and trainers of activities you've recently joined",

    // `recent-teachers-teacher-card-button-class-schedule`:
    // View schedule
    params => "" +
      "View schedule",

    // `recent-teachers-teacher-card-button-no-classes-available`:
    // No classes available
    params => "" +
      "No classes available",

    // `recent-teachers-teacher-card-button-venue-overview`:
    // View venue profile
    params => "" +
      "View venue profile",

    // `recommendations`:
    // Recommendations
    params => "" +
      "Recommendations",

    // `recommendations-banner-label-discover-offers`:
    // Trial offers
    params => "" +
      "Trial offers",

    // `recommendations-banner-label-recent-teachers`:
    // Your teachers & trainers
    params => "" +
      "Your teachers & trainers",

    // `recommendations-hero-subtitle`:
    // Not sure what to do next? Check out what your recent trainers and teachers are offering lately, or try something new for less with trial offers for newcomers at several studios and venues in your area.
    params => "" +
      "Not sure what to do next? Check out what your recent trainers and teachers are offering lately, or try something new for less with trial offers for newcomers at several studios and venues in your area.",

    // `recommendations-hero-title`:
    // Discover your next favorite activity
    params => "" +
      "Discover your next favorite activity",

    // `recommendations-meta-description`:
    // Check out what trainers and teachers from your recent activities are offering soon, or try something new for less money and get inspired by the trial offers of various studios and facilities in your area.
    params => "" +
      "Check out what trainers and teachers from your recent activities are offering soon, or try something new for less money and get inspired by the trial offers of various studios and facilities in your area.",

    // `recommendations-meta-title`:
    // Eversports - Discover your next sport activity
    params => "" +
      "Eversports - Discover your next sport activity",

    // `recommendations-page-title`:
    // Recommendations
    params => "" +
      "Recommendations",

    // `remove-players-action`:
    // Remove players
    params => "" +
      "Remove players",

    // `remove-players-button`:
    // Remove co-players
    params => "" +
      "Remove co-players",

    // `remove-players-title`:
    // Remove co-players
    params => "" +
      "Remove co-players",

    // `requested-friendship-button-text`:
    // Requested
    params => "" +
      "Requested",

    // `reset-participation-rule`:
    // Reset
    params => "" +
      "Reset",

    // `retreats-offering-heading`:
    // Retreats
    params => "" +
      "Retreats",

    // `rueckenfit`:
    // Backfit
    params => "" +
      "Backfit",

    // `save-rules-and-continue`:
    // Save and continue
    params => "" +
      "Save and continue",

    // `save-to-calendar`:
    // Calendar
    params => "" +
      "Calendar",

    // `saved-organizer-note`:
    // Saved
    params => "" +
      "Saved",

    // `schwimmen`:
    // Swimming
    params => "" +
      "Swimming",

    // `scroll-left-label`:
    // Scroll left
    params => "" +
      "Scroll left",

    // `scroll-right-label`:
    // Scroll right
    params => "" +
      "Scroll right",

    // `search-cancel-button-text`:
    // Close
    params => "" +
      "Close",

    // `search-category-activities-in-your-city`:
    // Activities in your city
    params => "" +
      "Activities in your city",

    // `search-category-venues-and-studios`:
    // Venues
    params => "" +
      "Venues",

    // `search-category-venues-in-your-city`:
    // Venues in your city
    params => "" +
      "Venues in your city",

    // `search-clear-button-title`:
    // Clear
    params => "" +
      "Clear",

    // `search-close-mobile-drawer`:
    // Close
    params => "" +
      "Close",

    // `search-current-location`:
    // Current Location
    params => "" +
      "Current Location",

    // `search-for-location-label`:
    // Location
    params => "" +
      "Location",

    // `search-for-sport`:
    // Search for a sport
    params => "" +
      "Search for a sport",

    // `search-for-sport-or-venue-label`:
    // Sport or Venue
    params => "" +
      "Sport or Venue",

    // `search-friends-sub-title`:
    // Names or @usernames
    params => "" +
      "Names or @usernames",

    // `search-friends-title`:
    // Search
    params => "" +
      "Search",

    // `search-geolocation-not-found-error-message`:
    // Location could not be determined. Please enable location sharing for this website in your browser settings.
    params => "" +
      "Location could not be determined. Please enable location sharing for this website in your browser settings.",

    // `search-input-placeholder-text`:
    // Search
    params => "" +
      "Search",

    // `search-inventory-placeholder-desktop`:
    // Search for a sport or venue name
    params => "" +
      "Search for a sport or venue name",

    // `search-inventory-placeholder-mobile`:
    // Sport or Venue
    params => "" +
      "Sport or Venue",

    // `search-no-results`:
    // No results could be found for "{query}"
    params => "" +
      "No results could be found for \"" +
      params.query +
      "\"",

    // `search-placeholder`:
    // Search for sports, cities or venues
    params => "" +
      "Search for sports, cities or venues",

    // `search-sport-in-city`:
    // {sportName} in {cityName}
    params => "" +
      params.sportName +
      " in " +
      params.cityName,

    // `search-submit-button-text`:
    // Search
    params => "" +
      "Search",

    // `search-suggested-results-text`:
    // Try one of these popular searches
    params => "" +
      "Try one of these popular searches",

    // `search-venues-in-city`:
    // All venues in {cityName}
    params => "" +
      "All venues in " +
      params.cityName,

    // `search-view-all-sports-in-city`:
    // All Sports around {cityName}
    params => "" +
      "All Sports around " +
      params.cityName,

    // `search-view-venues-and-studios`:
    // Discover all venues
    params => "" +
      "Discover all venues",

    // `see-less-content`:
    // See Less
    params => "" +
      "See Less",

    // `see-more-content`:
    // See More
    params => "" +
      "See More",

    // `see-more-sports`:
    // More
    params => "" +
      "More",

    // `sent-friend-requests-title`:
    // Sent by you ({count})
    params => "" +
      "Sent by you (" +
      formatter_0(params.count) +
      ")",

    // `settings-button`:
    // Settings
    params => "" +
      "Settings",

    // `share-activity-detail`:
    // Share
    params => "" +
      "Share",

    // `share-it`:
    // Share it
    params => "" +
      "Share it",

    // `share-match`:
    // Share
    params => "" +
      "Share",

    // `share-user-profile-button`:
    // {userType, select, 
    //  OWNER {Share my profile} 
    //  other {Share this profile}}
    params => "" +
      (
        params.userType == "OWNER" ? "" +
          "Share my profile" :
        "" +
          "Share this profile"
      ),

    // `share-venue-profile`:
    // Share
    params => "" +
      "Share",

    // `share-with-friends`:
    // Share with your friends
    params => "" +
      "Share with your friends",

    // `share-your-profile`:
    // Share your profile
    params => "" +
      "Share your profile",

    // `share-your-profile-call-to-action`:
    // Connect with your friends
    params => "" +
      "Connect with your friends",

    // `share-your-profile-description`:
    // Share your profile link, so others can add you as their friend
    params => "" +
      "Share your profile link, so others can add you as their friend",

    // `sharing-actions-copy-link`:
    // Copy link
    params => "" +
      "Copy link",

    // `sharing-actions-copy-text`:
    // Copy text
    params => "" +
      "Copy text",

    // `sharing-actions-email`:
    // Email
    params => "" +
      "Email",

    // `sharing-actions-message`:
    // Message
    params => "" +
      "Message",

    // `sharing-actions-whatsapp`:
    // WhatsApp
    params => "" +
      "WhatsApp",

    // `similar-sports-in-city-heading`:
    // Similar sports and styles of {sportName}
    params => "" +
      "Similar sports and styles of " +
      params.sportName,

    // `sport-in-city`:
    // {sportName} in {cityName}
    params => "" +
      params.sportName +
      " in " +
      params.cityName,

    // `sport-tag-sport-in-city`:
    // {sportName} in {cityName}
    params => "" +
      params.sportName +
      " in " +
      params.cityName,

    // `sporttags-section-show-less-results`:
    // Show less
    params => "" +
      "Show less",

    // `sporttags-section-show-more-results`:
    // Show more
    params => "" +
      "Show more",

    // `squash`:
    // Squash
    params => "" +
      "Squash",

    // `static-map-venue-marker`:
    // Map marker for the venue's location
    params => "" +
      "Map marker for the venue's location",

    // `store-badge-apple-store`:
    // App Store
    params => "" +
      "App Store",

    // `store-badge-get-it-on`:
    // Get it on
    params => "" +
      "Get it on",

    // `store-badge-google-play`:
    // Google Play
    params => "" +
      "Google Play",

    // `stretching`:
    // Stretching
    params => "" +
      "Stretching",

    // `studios-heading`:
    // Venues
    params => "" +
      "Venues",

    // `subscribe-to-newsletter-description`:
    // Subscribe to Marketing Communication (e.g. newsletter, promotions) from {venueName}
    params => "" +
      "Subscribe to Marketing Communication (e.g. newsletter, promotions) from " +
      params.venueName,

    // `subscribe-to-newsletter-subscribe`:
    // Subscribe
    params => "" +
      "Subscribe",

    // `subscribe-to-newsletter-subscribed`:
    // Subscribed
    params => "" +
      "Subscribed",

    // `subscribe-to-newsletter-title`:
    // Get the latest News & Updates
    params => "" +
      "Get the latest News & Updates",

    // `subscribe-to-newsletter-unsubscribe-info`:
    // You can unsubscribe at any time via the link in the email footer
    params => "" +
      "You can unsubscribe at any time via the link in the email footer",

    // `suggested-friend-joined-activities`:
    // Joined activities together
    params => "" +
      "Joined activities together",

    // `suggested-friend-mutual-friends`:
    // {count, plural, one {}=1 {1 mutual friend}
    //  other {{count} mutual friends}}
    params => "" +
      (
        context.p(params.count) == "one" ? "" :
        params.count == 1 ? "" +
          "1 mutual friend" :
        "" +
          formatter_0(params.count) +
          " mutual friends"
      ),

    // `suggested-friends-show-all`:
    // Show all
    params => "" +
      "Show all",

    // `suggested-friends-title`:
    // Suggested friends
    params => "" +
      "Suggested friends",

    // `sync-contacts-sub-title`:
    // Connect with friends you know
    params => "" +
      "Connect with friends you know",

    // `sync-contacts-title`:
    // Find contacts
    params => "" +
      "Find contacts",

    // `tanzen`:
    // Dance
    params => "" +
      "Dance",

    // `technical-notes-heading`:
    // Technical notes
    params => "" +
      "Technical notes",

    // `tennis`:
    // Tennis
    params => "" +
      "Tennis",

    // `testimonial-alexis-austria`:
    // Love using eversports to book Padel courts around the city and share the match with my friends!
    params => "" +
      "Love using eversports to book Padel courts around the city and share the match with my friends!",

    // `testimonial-camille-netherlands`:
    // Had the opportunity to partake in both aerial sports and Latin dancing through this app. Gave me lots of flexibility and freedom
    params => "" +
      "Had the opportunity to partake in both aerial sports and Latin dancing through this app. Gave me lots of flexibility and freedom",

    // `testimonial-claudia-netherlands`:
    // Quick and easy navigation to find a gym or yoga class close to my home, which saves a lot of time!
    params => "" +
      "Quick and easy navigation to find a gym or yoga class close to my home, which saves a lot of time!",

    // `this-profile-information-is-only-visible-to-connected-users`:
    // This profile information is only available to friends!
    params => "" +
      "This profile information is only available to friends!",

    // `tld-country-name`:
    // {tld, select, 
    //  at {Austria} 
    //  de {Germany} 
    //  nl {the Netherlands} 
    //  fr {France} 
    //  ch {Switzerland} 
    //  es {Spain} 
    //  it {Italy} 
    //  be {Belgium} 
    //  other {}}
    params => "" +
      (
        params.tld == "at" ? "" +
          "Austria" :
        params.tld == "de" ? "" +
          "Germany" :
        params.tld == "nl" ? "" +
          "the Netherlands" :
        params.tld == "fr" ? "" +
          "France" :
        params.tld == "ch" ? "" +
          "Switzerland" :
        params.tld == "es" ? "" +
          "Spain" :
        params.tld == "it" ? "" +
          "Italy" :
        params.tld == "be" ? "" +
          "Belgium" :
        ""
      ),

    // `today`:
    // Today
    params => "" +
      "Today",

    // `tomorrow`:
    // Tomorrow
    params => "" +
      "Tomorrow",

    // `tooltip-copied-link`:
    // Link copied ✅
    params => "" +
      "Link copied ✅",

    // `tooltip-copied-text`:
    // Text copied ✅
    params => "" +
      "Text copied ✅",

    // `trainer-image-alt-text`:
    // Trainer profile picture
    params => "" +
      "Trainer profile picture",

    // `trainings-offering-heading`:
    // Trainings
    params => "" +
      "Trainings",

    // `trial-offers-has-more`:
    // & more
    params => "" +
      "& more",

    // `trial-offers-subtitle`:
    // Check out special intro offers, free trials, and deals for newcomers of studios and venues in your area
    params => "" +
      "Check out special intro offers, free trials, and deals for newcomers of studios and venues in your area",

    // `trial-offers-title`:
    // Trial offers and newcomer deals
    params => "" +
      "Trial offers and newcomer deals",

    // `unexpected-error-description`:
    // Please try again later. If the page still does not work for you please contact us here: support@eversports.com
    params => "" +
      "Please try again later. If the page still does not work for you please contact us here: support@eversports.com",

    // `unexpected-error-message`:
    // There seems to be a problem
    params => "" +
      "There seems to be a problem",

    // `unlimited-players`:
    // Unlimited
    params => "" +
      "Unlimited",

    // `user-connection-tooltip-friends-of-user-description`:
    // See if there are people you might know.
    params => "" +
      "See if there are people you might know.",

    // `user-connection-tooltip-friends-of-user-title`:
    // 💡 Find more friends!
    params => "" +
      "💡 Find more friends!",

    // `user-connection-tooltip-share-your-profile-description`:
    // Share your profile with others, so they can add you to their friends
    params => "" +
      "Share your profile with others, so they can add you to their friends",

    // `user-connection-tooltip-share-your-profile-title`:
    // 🔥 Connect with friends! 
    params => "" +
      "🔥 Connect with friends! ",

    // `user-connection-tooltip-upcoming-bookings-description`:
    // Define who can see your upcoming activities
    params => "" +
      "Define who can see your upcoming activities",

    // `user-connection-tooltip-upcoming-bookings-title`:
    // Who is allowed to see this?
    params => "" +
      "Who is allowed to see this?",

    // `user-friends-page-meta-description`:
    // Check {userFirstName}’s friends on Eversports
    params => "" +
      "Check " +
      params.userFirstName +
      "’s friends on Eversports",

    // `user-friends-page-meta-title`:
    // {userFirstName}'s friends
    params => "" +
      params.userFirstName +
      "'s friends",

    // `user-interview-registration-english`:
    // English
    params => "" +
      "English",

    // `user-interview-registration-german`:
    // German
    params => "" +
      "German",

    // `user-interview-registration-meta-description`:
    // Create a better Eversports by showing us how
    params => "" +
      "Create a better Eversports by showing us how",

    // `user-interview-registration-meta-title`:
    // Register for a user interview with Eversports
    params => "" +
      "Register for a user interview with Eversports",

    // `user-interview-registration-title`:
    // Choose the interview language & schedule an online meeting
    params => "" +
      "Choose the interview language & schedule an online meeting",

    // `user-menu-drawer-welcome-with-comma`:
    // Welcome,
    params => "" +
      "Welcome,",

    // `user-menu-item-for-businesses`:
    // For Sports Providers
    params => "" +
      "For Sports Providers",

    // `user-menu-item-for-corporates`:
    // For companies
    params => "" +
      "For companies",

    // `user-menu-item-home`:
    // Home
    params => "" +
      "Home",

    // `user-menu-item-login`:
    // Login
    params => "" +
      "Login",

    // `user-menu-item-login-or-register`:
    // Login - Register
    params => "" +
      "Login - Register",

    // `user-menu-item-my-bookings`:
    // My Bookings
    params => "" +
      "My Bookings",

    // `user-menu-item-my-favorites`:
    // My Favorites
    params => "" +
      "My Favorites",

    // `user-menu-item-my-friends`:
    // My friends
    params => "" +
      "My friends",

    // `user-menu-item-my-passes-and-memberships`:
    // My Passes & Memberships
    params => "" +
      "My Passes & Memberships",

    // `user-menu-item-my-payment-methods`:
    // My Payment Methods
    params => "" +
      "My Payment Methods",

    // `user-menu-item-my-personal-information`:
    // My Personal Information
    params => "" +
      "My Personal Information",

    // `user-menu-item-my-public-profile`:
    // My Profile
    params => "" +
      "My Profile",

    // `user-menu-item-my-videos`:
    // My Videos
    params => "" +
      "My Videos",

    // `user-menu-item-register`:
    // Register
    params => "" +
      "Register",

    // `user-menu-item-signout`:
    // Signout
    params => "" +
      "Signout",

    // `user-menu-new-tag`:
    // New
    params => "" +
      "New",

    // `user-profile-favourite-venues-show-all-button`:
    // Show all
    params => "" +
      "Show all",

    // `user-profile-favourite-venues-title`:
    // Favorite Venues
    params => "" +
      "Favorite Venues",

    // `user-profile-friend-no-upcoming-bookings`:
    // No upcoming activities.
    params => "" +
      "No upcoming activities.",

    // `user-profile-friends-no-favourite-venues`:
    // Your friend doesn't have favorite venues yet.
    params => "" +
      "Your friend doesn't have favorite venues yet.",

    // `user-profile-no-favourite-venues`:
    // No favourite venues yet.
    params => "" +
      "No favourite venues yet.",

    // `user-profile-no-upcoming-bookings`:
    // You have no upcoming activities.
    params => "" +
      "You have no upcoming activities.",

    // `user-profile-no-upcoming-bookings-link`:
    // Book your next activity
    params => "" +
      "Book your next activity",

    // `user-profile-private-information`:
    // This information is set to private by the account owner
    params => "" +
      "This information is set to private by the account owner",

    // `user-profile-sharing-message`:
    // Add me on Eversports! 🙂
    //  ➡️ {url}
    params => "" +
      "Add me on Eversports! 🙂\n ➡️ " +
      params.url,

    // `user-profile-upcoming-bookings-show-all-button`:
    // Show all
    params => "" +
      "Show all",

    // `user-profile-upcoming-bookings-title`:
    // Upcoming Activities
    params => "" +
      "Upcoming Activities",

    // `user-search-results-not-found`:
    // No users by "{searchTerm}" were found
    params => "" +
      "No users by \"" +
      params.searchTerm +
      "\" were found",

    // `venue-amenity-changing-room`:
    // Changing rooms
    params => "" +
      "Changing rooms",

    // `venue-amenity-food`:
    // Food
    params => "" +
      "Food",

    // `venue-amenity-parking`:
    // Parking lot
    params => "" +
      "Parking lot",

    // `venue-amenity-pay-with-card`:
    // Card Payment
    params => "" +
      "Card Payment",

    // `venue-amenity-shop-and-rental`:
    // Shop
    params => "" +
      "Shop",

    // `venue-amenity-shower`:
    // Showers
    params => "" +
      "Showers",

    // `venue-amenity-wellness-offer`:
    // Wellness
    params => "" +
      "Wellness",

    // `venue-is-in-favorites`:
    // Favorited
    params => "" +
      "Favorited",

    // `venue-logo-alt-text`:
    // Venue logo
    params => "" +
      "Venue logo",

    // `venue-newsletter-subscription-call-to-action`:
    // Subscribe to Newsletter
    params => "" +
      "Subscribe to Newsletter",

    // `venue-newsletter-subscription-sub-title`:
    // Receive all news and updates from the venue
    params => "" +
      "Receive all news and updates from the venue",

    // `venue-newsletter-subscription-success`:
    // Subscribed
    params => "" +
      "Subscribed",

    // `venue-newsletter-subscription-title`:
    // Stay up-to-date
    params => "" +
      "Stay up-to-date",

    // `venue-profile-about-title`:
    // About us
    params => "" +
      "About us",

    // `venue-profile-amenities-title`:
    // Amenities
    params => "" +
      "Amenities",

    // `venue-profile-book-now`:
    // Book Now
    params => "" +
      "Book Now",

    // `venue-profile-cheapest-price`:
    // Prices from
    params => "" +
      "Prices from",

    // `venue-profile-content-read-less`:
    // See less
    params => "" +
      "See less",

    // `venue-profile-content-read-more`:
    // See more
    params => "" +
      "See more",

    // `venue-profile-frequently-asked-questions`:
    // Frequently Asked Questions
    params => "" +
      "Frequently Asked Questions",

    // `venue-profile-further-info-title`:
    // Further helpful information
    params => "" +
      "Further helpful information",

    // `venue-profile-label-review-count`:
    // {reviewCount} reviews
    params => "" +
      formatter_0(params.reviewCount) +
      " reviews",

    // `venue-profile-location-title`:
    // Location
    params => "" +
      "Location",

    // `venue-profile-match-promotion-banner-new-tag`:
    // New
    params => "" +
      "New",

    // `venue-profile-match-promotion-banner-sub-title`:
    // Play together with users from the Eversports community
    params => "" +
      "Play together with users from the Eversports community",

    // `venue-profile-match-promotion-banner-title`:
    // Join a Match
    params => "" +
      "Join a Match",

    // `venue-profile-meet-the-team`:
    // About the Team
    params => "" +
      "About the Team",

    // `venue-profile-meta-description`:
    // Book {venueName} on Eversports. View up-to-date schedules, reserve your spot, and easily manage your bookings online! Browse all {listOfSportNames} offered by {venueName}.
    params => "" +
      "Book " +
      params.venueName +
      " on Eversports. View up-to-date schedules, reserve your spot, and easily manage your bookings online! Browse all " +
      params.listOfSportNames +
      " offered by " +
      params.venueName +
      ".",

    // `venue-profile-meta-title`:
    // {venueName} | {zip} {cityName} | Book Online
    params => "" +
      params.venueName +
      " | " +
      params.zip +
      " " +
      params.cityName +
      " | Book Online",

    // `venue-profile-more-locations-tag`:
    // 1 out of {locationCount} locations
    params => "" +
      "1 out of " +
      formatter_0(params.locationCount) +
      " locations",

    // `venue-profile-no-review-comments`:
    // There are no reviews yet
    params => "" +
      "There are no reviews yet",

    // `venue-profile-offered-sports`:
    // Available sports types and activities
    params => "" +
      "Available sports types and activities",

    // `venue-profile-online-meta-title`:
    // {venueName} | Book Online
    params => "" +
      params.venueName +
      " | Book Online",

    // `venue-profile-sharing-message`:
    // I just found {venueName} on Eversports! 
    //  
    //  ➡️ Check out their schedule: {url}
    params => "" +
      "I just found " +
      params.venueName +
      " on Eversports! \n \n ➡️ Check out their schedule: " +
      params.url,

    // `venue-profile-team-page-title`:
    // {venueName} - Team
    params => "" +
      params.venueName +
      " - Team",

    // `venue-profile-team-title`:
    // Team
    params => "" +
      "Team",

    // `venue-profile-title-reviews`:
    // Reviews
    params => "" +
      "Reviews",

    // `venue-profile-trainers-has-more`:
    // & more
    params => "" +
      "& more",

    // `venue-profile-trial-offer-price`:
    // Trial offers from
    params => "" +
      "Trial offers from",

    // `venue-profile-view-image-gallery-button`:
    // View image gallery
    params => "" +
      "View image gallery",

    // `venue-tab-camps`:
    // Camps
    params => "" +
      "Camps",

    // `venue-tab-classes`:
    // Classes
    params => "" +
      "Classes",

    // `venue-tab-courses`:
    // Courses
    params => "" +
      "Courses",

    // `venue-tab-educations`:
    // Educations
    params => "" +
      "Educations",

    // `venue-tab-events`:
    // Events
    params => "" +
      "Events",

    // `venue-tab-more`:
    // More
    params => "" +
      "More",

    // `venue-tab-open-trainings`:
    // Open trainings
    params => "" +
      "Open trainings",

    // `venue-tab-overview`:
    // Overview
    params => "" +
      "Overview",

    // `venue-tab-public-matches`:
    // Matches
    params => "" +
      "Matches",

    // `venue-tab-retreats`:
    // Retreats
    params => "" +
      "Retreats",

    // `venue-tab-shop`:
    // Prices
    params => "" +
      "Prices",

    // `venue-tab-sports-fields`:
    // Sports fields
    params => "" +
      "Sports fields",

    // `venue-tab-team`:
    // Team
    params => "" +
      "Team",

    // `venue-tab-trainings`:
    // Trainings
    params => "" +
      "Trainings",

    // `venue-tab-videos`:
    // Videos
    params => "" +
      "Videos",

    // `venue-tab-workshops`:
    // Workshops
    params => "" +
      "Workshops",

    // `videos-offering-heading`:
    // Videos
    params => "" +
      "Videos",

    // `view-all`:
    // View all
    params => "" +
      "View all",

    // `visibility-setting-description-friend`:
    // This section is only visible to you and your friends.
    params => "" +
      "This section is only visible to you and your friends.",

    // `visibility-setting-description-private`:
    // This section is only visible to you.
    params => "" +
      "This section is only visible to you.",

    // `visibility-setting-description-public`:
    // This section is visible to everyone.
    params => "" +
      "This section is visible to everyone.",

    // `visibility-setting-modal-apply-button`:
    // Save
    params => "" +
      "Save",

    // `visibility-setting-modal-description`:
    // Define, who can view the information displayed on this section.
    params => "" +
      "Define, who can view the information displayed on this section.",

    // `visibility-setting-modal-dismiss-button`:
    // Dismiss
    params => "" +
      "Dismiss",

    // `visibility-setting-modal-title`:
    // Visibility Settings
    params => "" +
      "Visibility Settings",

    // `visibility-setting-title-friend`:
    // Only Friends
    params => "" +
      "Only Friends",

    // `visibility-setting-title-private`:
    // Only me
    params => "" +
      "Only me",

    // `visibility-setting-title-public`:
    // Public
    params => "" +
      "Public",

    // `what-is-new`:
    // What's new
    params => "" +
      "What's new",

    // `what-is-the-corporate-program-answer`:
    // By partnering with Eversports, companies can provide their employees with a budget that can be used at any of our 3.500 partner sports venues. Some of these partner sports venues offer exclusive discounts to users that are part of the corporate program.
    params => "" +
      "By partnering with Eversports, companies can provide their employees with a budget that can be used at any of our 3.500 partner sports venues. Some of these partner sports venues offer exclusive discounts to users that are part of the corporate program.",

    // `what-is-the-corporate-program-question`:
    // What is the Eversports Corporate Program?
    params => "" +
      "What is the Eversports Corporate Program?",

    // `which-venues-offer-corporate-discounts-answer`:
    // To find which venues offer exclusive Corporate Deals, go to the Eversports discover page and use the Trial Offers and Deals filter. From there, filter for Corporate Deals.
    params => "" +
      "To find which venues offer exclusive Corporate Deals, go to the Eversports discover page and use the Trial Offers and Deals filter. From there, filter for Corporate Deals.",

    // `which-venues-offer-corporate-discounts-question`:
    // Which Venues Offer Exclusive Discounts?
    params => "" +
      "Which Venues Offer Exclusive Discounts?",

    // `workshops-offering-heading`:
    // Workshops
    params => "" +
      "Workshops",

    // `yearly-recap-active-days-section-subtitle`:
    // What an active year for you! Keep it up in {year}!
    params => "" +
      "What an active year for you! Keep it up in " +
      params.year +
      "!",

    // `yearly-recap-active-days-section-title`:
    // {totalDaysCount} active days
    params => "" +
      formatter_0(params.totalDaysCount) +
      " active days",

    // `yearly-recap-active-days-section-title-text`:
    // active days
    params => "" +
      "active days",

    // `yearly-recap-active-days-subtitle-tier-1`:
    // Great accomplishment! You made time for yourself and your well-being – that's always worth celebrating.
    params => "" +
      "Great accomplishment! You made time for yourself and your well-being – that's always worth celebrating.",

    // `yearly-recap-active-days-subtitle-tier-2`:
    // Amazing work! You're turning activity into a part of your lifestyle. Keep making those moves!
    params => "" +
      "Amazing work! You're turning activity into a part of your lifestyle. Keep making those moves!",

    // `yearly-recap-active-days-subtitle-tier-3`:
    // Well done! You've made being active a regular part of your life. Keep it up!
    params => "" +
      "Well done! You've made being active a regular part of your life. Keep it up!",

    // `yearly-recap-active-days-subtitle-tier-4`:
    // Great consistency! You've built a solid routine, and it's inspiring.
    params => "" +
      "Great consistency! You've built a solid routine, and it's inspiring.",

    // `yearly-recap-active-days-subtitle-tier-5`:
    // You're unstoppable! Celebrate your strength and dedication!
    params => "" +
      "You're unstoppable! Celebrate your strength and dedication!",

    // `yearly-recap-active-minutes-section-title-text`:
    // active minutes
    params => "" +
      "active minutes",

    // `yearly-recap-banner-subtitle`:
    // Check it out now
    params => "" +
      "Check it out now",

    // `yearly-recap-banner-title`:
    // Your {year} Recap is live!
    params => "" +
      "Your " +
      params.year +
      " Recap is live!",

    // `yearly-recap-favourite-venue-subtitle`:
    // {venueName} became your second home, a place where you pushed your limits and recharged your energy.
    params => "" +
      params.venueName +
      " became your second home, a place where you pushed your limits and recharged your energy.",

    // `yearly-recap-minutes-active-subtitle-tier-1`:
    // You’ve made time for movement, and every bit counts. Keep going at your own pace!
    params => "" +
      "You’ve made time for movement, and every bit counts. Keep going at your own pace!",

    // `yearly-recap-minutes-active-subtitle-tier-2`:
    // Great job! Your active minutes this year shows your commitment to staying active.
    params => "" +
      "Great job! Your active minutes this year shows your commitment to staying active.",

    // `yearly-recap-minutes-active-subtitle-tier-3`:
    // Consistency pays off, and your activity this year is a testament to your dedication.
    params => "" +
      "Consistency pays off, and your activity this year is a testament to your dedication.",

    // `yearly-recap-minutes-active-subtitle-tier-4`:
    // Amazing work! With several thousands of active minutes this year, you’ve shown just how unstoppable you are.
    params => "" +
      "Amazing work! With several thousands of active minutes this year, you’ve shown just how unstoppable you are.",

    // `yearly-recap-minutes-active-subtitle-tier-5`:
    // You absolutely crushed it - Your activity proves your passion and commitment to your well-being.
    params => "" +
      "You absolutely crushed it - Your activity proves your passion and commitment to your well-being.",

    // `yearly-recap-most-active-month-section-subtitle`:
    // was your most active month in 2023 with {monthBookingCount} active days! 💪
    params => "" +
      "was your most active month in 2023 with " +
      formatter_0(params.monthBookingCount) +
      " active days! 💪",

    // `yearly-recap-most-active-month-section-title`:
    // {monthName}
    params => [
      params.monthName,
    ],

    // `yearly-recap-most-active-month-subtitle`:
    // {mostActiveMonthName} stood out as your most active month with {mostActiveMonthActivityCount} active days. Plenty of energy and movement. Great job staying consistent!
    params => "" +
      params.mostActiveMonthName +
      " stood out as your most active month with " +
      formatter_0(params.mostActiveMonthActivityCount) +
      " active days. Plenty of energy and movement. Great job staying consistent!",

    // `yearly-recap-online-bookings-only-disclaimer`:
    // * Only online bookings via Eversports are considered for this recap
    params => "" +
      "* Only online bookings via Eversports are considered for this recap",

    // `yearly-recap-overview-streak-description`:
    // Longest Streak
    params => "" +
      "Longest Streak",

    // `yearly-recap-overview-title`:
    // Your {year} Recap
    params => [
      "Your ",
      params.year,
      " Recap",
    ],

    // `yearly-recap-overview-top-friend-description`:
    // Your Top Friend
    params => "" +
      "Your Top Friend",

    // `yearly-recap-overview-top-sport-description`:
    // Top Sport
    params => "" +
      "Top Sport",

    // `yearly-recap-overview-top-teacher-description`:
    // Your Top Trainer
    params => "" +
      "Your Top Trainer",

    // `yearly-recap-overview-top-venue-description`:
    // Top Venue
    params => "" +
      "Top Venue",

    // `yearly-recap-overview-total-days-description`:
    // Active Days in Total
    params => "" +
      "Active Days in Total",

    // `yearly-recap-overview-total-days-title`:
    // {totalDaysCount} days
    params => "" +
      formatter_0(params.totalDaysCount) +
      " days",

    // `yearly-recap-overview-total-minutes-description`:
    // Active Minutes
    params => "" +
      "Active Minutes",

    // `yearly-recap-overview-total-minutes-title`:
    // {totalMinutes} minutes
    params => "" +
      formatter_0(params.totalMinutes) +
      " minutes",

    // `yearly-recap-overview-total-sports-description`:
    // you've tried in 2023
    params => "" +
      "you've tried in 2023",

    // `yearly-recap-overview-total-sports-title`:
    // {totalSportsCount} sports
    params => "" +
      formatter_0(params.totalSportsCount) +
      " sports",

    // `yearly-recap-page-meta-description`:
    // Check out {firstName}'s yearly recap on Eversports
    params => "" +
      "Check out " +
      params.firstName +
      "'s yearly recap on Eversports",

    // `yearly-recap-page-meta-title`:
    // Eversports - {firstName}'s Yearly Recap
    params => "" +
      "Eversports - " +
      params.firstName +
      "'s Yearly Recap",

    // `yearly-recap-share-button`:
    // Share your {year} recap
    params => "" +
      "Share your " +
      params.year +
      " recap",

    // `yearly-recap-share-section-button`:
    // Share
    params => "" +
      "Share",

    // `yearly-recap-sharing-message`:
    // Hey, checkout {userFirstName}'s {year} Eversports Recap 🎉 
    //  
    // ➡️ {recapUrl}
    params => "" +
      "Hey, checkout " +
      params.userFirstName +
      "'s " +
      params.year +
      " Eversports Recap 🎉 \n \n➡️ " +
      params.recapUrl,

    // `yearly-recap-sports-count-subtitle-tier-1`:
    // You stayed loyal to your passion this year, focusing on mastering every move in {topSportName}. Dedication at its finest!
    params => "" +
      "You stayed loyal to your passion this year, focusing on mastering every move in " +
      params.topSportName +
      ". Dedication at its finest!",

    // `yearly-recap-sports-count-subtitle-tier-2`:
    // A versatile year! You explored multiple sports, keeping things fresh and exciting.!
    params => "" +
      "A versatile year! You explored multiple sports, keeping things fresh and exciting.!",

    // `yearly-recap-sports-count-subtitle-tier-3`:
    // What a journey! You’ve embraced variety, challenging yourself across several sports.
    params => "" +
      "What a journey! You’ve embraced variety, challenging yourself across several sports.",

    // `yearly-recap-sports-count-subtitle-tier-4`:
    // Your adventurous spirit shone through this year, trying out so many different sports. You're unstoppable!
    params => "" +
      "Your adventurous spirit shone through this year, trying out so many different sports. You're unstoppable!",

    // `yearly-recap-sports-count-subtitle-tier-5`:
    // A true explorer of the sports world! You’ve gone above and beyond, conquering every challenge in your path.
    params => "" +
      "A true explorer of the sports world! You’ve gone above and beyond, conquering every challenge in your path.",

    // `yearly-recap-sports-section-subtitle`:
    // have made your life more enjoyable!
    params => "" +
      "have made your life more enjoyable!",

    // `yearly-recap-sports-section-title`:
    // {totalSportsCount} sports
    params => "" +
      formatter_0(params.totalSportsCount) +
      " sports",

    // `yearly-recap-streak-section-title-text`:
    // Longest streak:
    params => "" +
      "Longest streak:",

    // `yearly-recap-streak-subtitle`:
    // Every day counts, and your longest streak proves how committed you are to your goals. Great job!
    params => "" +
      "Every day counts, and your longest streak proves how committed you are to your goals. Great job!",

    // `yearly-recap-subtitle`:
    // Let's take a look at {year} and see what you have achieved!
    params => "" +
      "Let's take a look at " +
      params.year +
      " and see what you have achieved!",

    // `yearly-recap-title`:
    // We had an awesome year with you, {firstName}! ❤️️
    params => "" +
      "We had an awesome year with you, " +
      params.firstName +
      "! ❤️️",

    // `yearly-recap-top-friend-subtitle`:
    // Your #1 partner in crime! This year, you did sports most often with {friendName}! They keep the energy high and the fun going, making every activity unforgettable.
    params => "" +
      "Your #1 partner in crime! This year, you did sports most often with " +
      params.friendName +
      "! They keep the energy high and the fun going, making every activity unforgettable.",

    // `yearly-recap-top-sport-section-subtitle`:
    // really captured your heart!
    params => "" +
      "really captured your heart!",

    // `yearly-recap-top-sport-subtitle`:
    // {sportName} was your champion this year, and it’s easy to see why. You’ve shown true passion and energy, making every moment count!
    params => "" +
      params.sportName +
      " was your champion this year, and it’s easy to see why. You’ve shown true passion and energy, making every moment count!",

    // `yearly-recap-top-teacher-subtitle`:
    // {teacherNickname} was your absolute favorite this year – no one else could make you sweat, curse, and still come back every single time!
    params => "" +
      params.teacherNickname +
      " was your absolute favorite this year – no one else could make you sweat, curse, and still come back every single time!",

    // `yearly-recap-top-venues-section-subtitle`:
    // was your favorite venue that you visited the most!
    params => "" +
      "was your favorite venue that you visited the most!",

    // `yearly-recap-total-minutes-section-subtitle`:
    // Great job! Keep on going like this!
    params => "" +
      "Great job! Keep on going like this!",

    // `yearly-recap-total-minutes-section-title`:
    // {totalMinutes} active minutes
    params => "" +
      formatter_0(params.totalMinutes) +
      " active minutes",

    // `yearly-recap-your-year`:
    // Your {year}
    params => "" +
      "Your " +
      params.year,

    // `yearly-recap-your-year-with-eversports`:
    // with Eversports
    params => "" +
      "with Eversports",

    // `yes`:
    // Yes
    params => "" +
      "Yes",

    // `yoga`:
    // Yoga
    params => "" +
      "Yoga",

    // `zirkeltraining`:
    // Circuit Training
    params => "" +
      "Circuit Training",

    // `zumba`:
    // Zumba
    params => "" +
      "Zumba",
  ];
};
